/*jshint unused:false*/
/*global fetch */
/*global console */

// Csrf Token
let form_token;
const keepTokenAlive = async function () {
  try {
    const resp = await fetch('/account/token', {
      method: 'GET',
    });
    if (resp.ok) {
      const data = await resp.json();
      if (data.token) {
        document.querySelectorAll('[name="_token"]').forEach(v => {
          v.setAttribute('value', data.token);
        });
        form_token = data.token;
      } else {
        console.log('Token not found in response');
      }
    } else {
      console.log(`Error: ${resp.status} ${resp.statusText}`);
    }
  } catch (error) {
    console.error('Fetch error:', error);
  }
};
document.addEventListener('DOMContentLoaded', (event) => {
  keepTokenAlive(); // Refresh token on page load
  setInterval(keepTokenAlive, 15 * 60 * 1000); // Refresh token every 15 minutes
});
// END Csrf Token

// Price toggles
let allSwitches = [].slice.call(document.querySelectorAll('.price-toggle'));
let priceContainers = [].slice.call(document.querySelectorAll('.deal-price-toggle'));
let priceSwitchForm = document.getElementById('price-switch');
let selected;
allSwitches.forEach((value) => {
  value.addEventListener('change', (val) => {
    (val.composedPath()[0].classList.contains('toggle-personal')) ? selected = 0 : selected = 1;
    if(val.composedPath()[0].classList.contains('price-toggle-checkbox')){
      (val.target.checked === true) ? selected = 1 : selected = 0;
    }
    toggleSwitches();
    togglePrices();
    updatePrice();
    camperDealBoxes()
  })
})
let toggleSwitches = () => {
  allSwitches.forEach((v) => {
    if(v.querySelector('.toggle-personal')){
      (selected === 0) ? v.querySelector('.toggle-personal').checked = true : v.querySelector('.toggle-business').checked = true;
    }
    (selected === 0) ? document.querySelector('#price-toggle-checkbox').checked = false : document.querySelector('#price-toggle-checkbox').checked = true;
  })
  document.querySelector("#switch-price-type").value = (selected === 0) ? 'Personal' : 'Business';
  document.querySelectorAll(".price-title-type").forEach((v) => {
    v.innerHTML = (selected === 0) ? 'Personal' : 'Business';
  })
}
let camperDealBoxes = () => {
  console.log((selected) )
  document.querySelectorAll('.deal-box-camper, .deal-box-kombi').forEach(value => {
    if (selected === 1) {
      value.querySelector('.price.price-purchase').dataset.hasdiscount = 'true';
      value.querySelector('.price-lease').classList.remove('visuallyhidden');
      value.querySelector('.price-contract > a').setAttribute('href', value.querySelector('.price-contract > a').getAttribute('href').replace('Personal', 'Business'))
    } else {
      value.querySelector('.price.price-purchase').dataset.hasdiscount = 'false';
      value.querySelector('.price-lease').classList.add('visuallyhidden');
      value.querySelector('.price-contract > a').setAttribute('href', value.querySelector('.price-contract > a').getAttribute('href').replace('Business', 'Personal'))
    }
  })

}
let togglePrices = () => {
  priceContainers.forEach((v) => {
    if(v.querySelector('.price-personal')){
      (selected === 0) ? v.querySelector('.price-personal').classList.add('active') : v.querySelector('.price-personal').classList.remove('active');
    }
    if(v.querySelector('.price-business')){
      (selected === 1) ? v.querySelector('.price-business').classList.add('active') : v.querySelector('.price-business').classList.remove('active');
    }
  })
}
let updatePrice = () => {
  let url = priceSwitchForm.getAttribute('action');
  let formData = new FormData(priceSwitchForm);
  fetch(url, {
    method: 'POST',
    processData: false,
    contentType: false,
    body: formData,
    headers: {
      'X-CSRF-TOKEN': document.querySelector("#price-switch [name=_token]").value,
      'X-Requested-With': 'XMLHttpRequest'
    },
  }).then(
    function(response) {
      if (response.status !== 200) {
        console.log('Looks like there was a problem. Status Code: ' + response.status);
        return;
      }
      response.json().then(function(data) {
        document.querySelector("#price-switch [name=_token]").value = data.token;
      });
    }
  ).catch(function(err) {
    console.log('Fetch Error :-S', err);
  });
}
// End price Toggles

// Back to top button
const scrollToTopButton = document.getElementById('back_to_top');
let smoothScrollCapture = (x) => {
  event.preventDefault();
  let id = x.currentTarget.target.getAttribute('href').split("#")[1]
  let el = document.getElementById(id);
  var x = el.getBoundingClientRect().left;
  var y = el.getBoundingClientRect().top;
  smoothScrollFunc(x, y)
}

let smoothScrollFunc = (x, y) => {
  event.preventDefault();
  window.scrollTo({
    top: y,
    left: x,
    behavior: 'smooth'
  });
}

window.addEventListener('DOMContentLoaded', () => {
  scrollToTopButton.addEventListener('click', () => {
    smoothScrollFunc(0, 0);
  })
})

window.addEventListener('scroll', () => {
  let pageHeight = document.body.scrollHeight;
  let currentHeight = window.scrollY;
  (currentHeight > (pageHeight/2)) ? scrollToTopButton.classList.add('active') : scrollToTopButton.classList.remove('active');
})
// End back to top button

/* MOBILE MODALS */
const navContainer = document.querySelector('.nav-container');
const hamburger = document.querySelector('#hamburger');

const modalMobileNav = new tingle.modal({
  footer: false,
  closeMethods: ['escape'],
  cssClass: ['mobile-nav','reversed']
});
modalMobileNav.setContent(document.querySelector('.site-menu').innerHTML);

// Nav modal
const handleToggle = () => {
  hamburger.classList.toggle('active');
  hamburger.classList.toggle('is-active');
  navContainer.classList.toggle('is-active');

  if(hamburger.classList.contains("active")) {
    modalMobileNav.open();
  } else{
    modalMobileNav.close();
  }
}

// Sticky class for navbar & modal
// window.onscroll = function() {stickyNav()};
// let navbar = document.getElementById('navbar');
// let tingleModal = document.querySelector('.tingle-modal');
// let sticky = navbar.offsetTop;
// function stickyNav() {
//   if (!document.body.classList.contains('tingle-enabled')) {
//     if (window.pageYOffset >= sticky) {
//       navbar.classList.add('is-sticky')
//       tingleModal.classList.add('is-sticky')
//     } else {
//       navbar.classList.remove('is-sticky')
//       tingleModal.classList.remove('is-sticky')
//     }
//   }
// }

hamburger.onclick = () => handleToggle();
hamburger.addEventListener('keyup', (event) => {
  if(event.keyCode === 13 || event.keyCode === 32) {
    handleToggle();
  }
});
/* END MOBILE MODALS */


  // Toggle search bar
  const searchToggleBtn = document.getElementById('toggle-search-btn');
  if (searchToggleBtn) {
    searchToggleBtn ? searchToggleBtn.addEventListener('click', () => {document.querySelector('.quick-search').classList.toggle('active')}) : '';
  }

  // Toggle Search Sidebar
  document.querySelectorAll('.toggle-search') ? document.querySelectorAll('.toggle-search').forEach((value) => {
    value.addEventListener('click', () => {
      document.body.classList.toggle('sidebar-active');
    })
  }) : null;
  // Close Search Sidebar
  document.querySelectorAll('.search-close') ? document.querySelectorAll('.search-close').forEach((value) => {
    value.addEventListener('click', () => {
      document.body.classList.remove('sidebar-active');
    })
  }) : null;

  // Header button click event
  const headerButtons = document.querySelectorAll('.search-vehicles-btn.open-sidebar');

  if (headerButtons.length > 0) {
    headerButtons.forEach((button) => {
      button.addEventListener('click', () => {
        localStorage.setItem('sidebarOpen', 'true');
      });
    });
  }

// Toggle loader when searching
  document.querySelector('.search-button') ? [].slice.call(document.querySelectorAll('.search-button')).forEach((value) => {
    value.addEventListener('click', () => {
      document.body.classList.remove('loaded')
    })
  }) : null;

//Dropdown Menu Toggle
var showMenu = function(){
    //div inside element contains dropdown menu
    var dropdown = this.parentNode.querySelector('div');
    var menuToggle = this;

    //if it's already active set it not to be
    if(dropdown.classList.contains("active")){
        dropdown.classList.toggle("active");
        menuToggle.classList.toggle("active");
        dropdown.classList.toggle("is-active");
        menuToggle.classList.toggle("is-active");
        return;
    }
    //get current active class
    var activeClass = document.querySelectorAll(".dropdown-menu .active");
    // make it not active
    if(activeClass!=null){
        for(var i=0; i<activeClass.length; i++){
          activeClass[i].classList.toggle("active");
          activeClass[i].classList.toggle("is-active");
        }
    }

    //apply active to the div inside element that contains dropdown menu
    dropdown.classList.toggle("active");
    dropdown.classList.toggle("is-active");
    menuToggle.classList.toggle("active");
    menuToggle.classList.toggle("is-active");
}

var menuDropdown = document.querySelectorAll(".dropdown-menu > a");

for(var i=0; i<menuDropdown.length; i++){
  menuDropdown[i].addEventListener('click', showMenu, false);
}

//faqs
// var faqSearch = document.querySelector('.faq-search input');
//
// if(faqSearch !== null){
//   faqSearch.addEventListener('keyup', function(e){
//     var results = document.getElementById('faq-results');
//     if(this.value.length != 0){
//       results.classList.add("active");
//     } else {
//       results.classList.remove("active");
//     }
//   });
// }

//More Options Toggle
// var classname = document.querySelectorAll(".more-options");
//
// var moreOptions = function(e) {
// 	e.preventDefault();
//   var element = document.getElementById("vehicle-search");
//   element.classList.toggle("active");
//   if(element.classList.contains('active')){
//     this.innerHTML = 'Hide additional options';
//   } else {
//     this.innerHTML = 'Show me more options';
//   }
// };
//
// for (var i = 0; i < classname.length; i++) {
//     classname[i].addEventListener('click', moreOptions, false);
// }

//Tab Content
function openTab(e, tabName) {
  let tabContent = document.querySelectorAll('.deal-tabs .tab-content');
  let tabLinks = document.querySelectorAll('.deal-tabs .tab');

  tabLinks.forEach((v) => {
    (v === e.target) ? e.target.classList.toggle('active') : v.classList.remove('active')
  });
  tabContent.forEach((v) => {
    (v.id === tabName) ? document.getElementById(tabName).classList.toggle('active') : v.classList.remove('active')
  });

}

//Search for Cars or Vans
// function showDesc(el){
//   el.style.display = 'none';
//   el.parentNode.querySelector('.extra').classList.remove('visuallyhidden');
// }

/**
  * SEARCH
  */
function searchType(elem, searchType) {
  var hiddenField, searchTab;

  //set hidden field value
  hiddenField = document.getElementById("search-type");
  hiddenField.setAttribute('value', searchType);

  //change header text
  // let headerSpan = document.getElementsByClassName("header-span");
  // for (let i = 0; i < headerSpan.length; i++) {
  //   (searchType === 'car') ? headerSpan[i].innerHTML = 'Car Lease' : headerSpan[i].innerHTML = 'Van Lease';
  // }

  //reset search values
  document.querySelector('.search-form [name=make]').value ='';
  document.querySelector('.search-form [name=model]').value ='';
  document.querySelector('.search-form [name=spec_level]').value ='';

  //hide Specs for Vans
  if (hiddenField.value === 'van'){
    document.querySelector('.search-form [name="spec_level"]').parentElement.classList.add('visuallyhidden');
  } else {
    document.querySelector('.search-form [name="spec_level"]').parentElement.classList.remove('visuallyhidden');
  }

  //remove active class
  searchTab = document.getElementsByClassName("search-tab");
  for (i = 0; i < searchTab.length; i++) {
    searchTab[i].className = searchTab[i].className.replace(" active", "");
  }

  //add active class to clicked
  elem.classList.toggle("active");

  loadManufacturers(document.querySelector('#search-type').value);
  loadBodyTypes(document.querySelector('#search-type').value);
}

function loadManufacturers($type) {
  if(window.location.pathname.includes('/used-evs')) {
    return false;
  }
  var make_dropdowns = document.getElementsByName("make");
  for (i = 0; i < make_dropdowns.length; i++) {

    var dropdown = make_dropdowns[0];
    dropdown.length = 0;

    var defaultOption = document.createElement('option');
    defaultOption.text = 'Any Make';
    defaultOption.value = '';

    dropdown.add(defaultOption);
    dropdown.selectedIndex = 0;

    var url = '/api/'+$type+'/manufacturers/available';

    if(document.querySelector('form.search-form')){
      if(window.location.pathname.includes('/special-offers') || window.location.search.includes('offers=specials')){
        url += '?specials=true';
      }
      if(window.location.pathname.includes('/stock') || window.location.search.includes('offers=stock')){
        url += '?stock=true';
      }
    }

    // console.log('loadManufacturers')
    fetch(url).then(function(response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' +
          response.status);
        return;
      }
      return response.json();
    }).then(function(data) {
      let keysSorted = Object.keys(data).sort(function(a, b) {
        return data[a].localeCompare(data[b])
      });
      for (let x in keysSorted) {
          let option = document.createElement('option');
          option.text = data[keysSorted[x]];
          option.value = keysSorted[x];
          dropdown.add(option);
      }
    }).catch(function(err) {
        console.error('Fetch Error -', err);
    });
  }
}

function loadModels($type, $manufacturer) {
  var model_dropdowns = document.getElementsByName("model");
  for (let i = 0; i < model_dropdowns.length; i++) {
    var dropdown = model_dropdowns[i];
    dropdown.length = 0;

    var defaultOption = document.createElement('option');
    defaultOption.text = 'Any Model';
    defaultOption.value = '';

    dropdown.add(defaultOption);
    dropdown.selectedIndex = 0;

    if ($manufacturer) {
      var url = '/api/' + $type + '/models/' + $manufacturer+'/available';

      if(document.querySelector('form.search-form')){
        if(window.location.pathname.includes('/special-offers') || window.location.search.includes('offers=specials')){
          url += '?specials=true';
        }
        if(window.location.pathname.includes('/stock') || window.location.search.includes('offers=stock')){
          url += '?stock=true';
        }
        if(window.location.pathname.includes('/used-evs')) {
           var url = '/api/used-evs/models/' + $manufacturer;
        }
      }

      // console.log('loadModels')
      fetch(url).then(function (response) {
        if (response.status !== 200) {
          console.warn('Looks like there was a problem. Status Code: ' +
            response.status);
          return;
        }
        return response.json();
      }).then(function (data) {
        let keysSorted = Object.keys(data).sort(function (a, b) {
          return data[a].localeCompare(data[b])
        });
        for (let x in keysSorted) {
          let option = document.createElement('option');
          option.text = data[keysSorted[x]];
          option.value = keysSorted[x];
          dropdown.add(option);
        }
      }).catch(function (err) {
        console.error('Fetch Error -', err);
      });
    }
  }
}

function loadSpecs($type, $model) {
  var dropdown = document.getElementsByName('spec_level')[0];
  dropdown.length = 0;

  var defaultOption = document.createElement('option');
  defaultOption.text = 'Any Spec';
  defaultOption.value = '';

  dropdown.add(defaultOption);
  dropdown.selectedIndex = 0;

  if($model) {
    var url = '/api/' + $type + '/specs/' + $model+'?available';

    if(document.querySelector('form.search-form')){
      if(window.location.pathname.includes('/special-offers') || window.location.search.includes('offers=specials')){
        url += '?specials=true';
      }
      if(window.location.pathname.includes('/stock') || window.location.search.includes('offers=stock')){
        url += '?stock=true';
      }
    }

    // console.log('loadSpecs')
    fetch(url).then(function (response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' +
          response.status);
        return;
      }
      return response.json();
    }).then(function (data) {
      let keysSorted = Object.keys(data).sort(function (a, b) {
        return data[a].localeCompare(data[b])
      });
      for (let x in keysSorted) {
        let option = document.createElement('option');
        option.text = data[keysSorted[x]];
        option.value = keysSorted[x];
        dropdown.add(option);
      }
    }).catch(function (err) {
      console.error('Fetch Error -', err);
    });
  }
}

function loadBodyTypes($type) {
  var dropdown = document.getElementsByName('body_type')[0];

  if(typeof dropdown == 'undefined'){
    return false;
  }

  dropdown.length = 0;

  var defaultOption = document.createElement('option');
  defaultOption.text = 'Any Body Type';
  defaultOption.value = '';

  dropdown.add(defaultOption);
  dropdown.selectedIndex = 0;

  var url = '/api/'+$type+'/types?available';
  url += document.querySelector('.search-form [name="make"]').value!='' ? '&make='+document.querySelector('.search-form [name="make"]').value : '';
  url += document.querySelector('.search-form [name="model"]').value!='' ? '&model='+document.querySelector('.search-form [name="model"]').value : '';
  if (document.querySelector('.search-form [name="spec_level"]')) {
    url += document.querySelector('.search-form [name="spec_level"]').value!='' ? '&spec_level='+document.querySelector('.search-form [name="spec_level"]').value : '';
  }

  // console.log('loadBodyTypes')
  fetch(url).then(function(response) {
    if (response.status !== 200) {
      console.warn('Looks like there was a problem. Status Code: ' +
        response.status);
      return;
    }
    return response.json();
  }).then(function(data) {
    let keysSorted = Object.keys(data).sort(function(a, b) {
      return data[a].localeCompare(data[b])
    });
    for (let x in keysSorted) {
      let option = document.createElement('option');
      option.text = data[keysSorted[x]];
      option.value = keysSorted[x];
      dropdown.add(option);
    }
  }).catch(function(err) {
      console.error('Fetch Error -', err);
  });
}

// if(document.getElementById('email-signup')){
//   document.getElementById('email-signup').addEventListener("click", function(e) {
//     e.preventDefault();
//
//     let url = '/newsletter';
//     let email = document.getElementById('newsletter-email').value;
//     let name = document.getElementById('newsletter-name').value;
//     let token = document.getElementsByName('_token')[0].value;
//
//     fetch(url, {
//       method: 'POST', // or 'PUT'
//       body: JSON.stringify({ 'name': name, 'first_name': name, 'email': email, '_token': token }), // data can be `string` or {object}!
//       headers:{
//         'Content-Type': 'application/json'
//       }}).then(function(response) {
//       if (response.status !== 200) {
//         console.warn('Looks like there was a problem. Status Code: ' +
//           response.status);
//         return;
//       }
//       return response.json();
//     }).then(function(data) {
//       if(data.status!='ok'){
//         let errors = '';
//         for (var i in data.errors) {
//           errors += data.errors[i][0]+'\n';
//         }
//         return alert('There was a problem with your sign up details\n\n'+$errors);
//       }
//
//       document.getElementsByClassName('newsletter-form')[0].reset();
//       document.cookie = "newsletter_dismissed=true";
//
//       // Trigger event tracking
//       window.dataLayer = window.dataLayer || [];
//       window.dataLayer.push({
//         'event': 'Newsletter Form Submit'
//       });
//       return alert('Thank you!');
//
//     }).catch(function(err) {
//       console.error('Fetch Error -', err);
//     });
//   });
// }

function loadSearchForm () {
  // Load Search Form
  if(document.getElementsByClassName('search-form').length>0){
    // Search
    let searchType = document.querySelector('#search-type').value;

    if (document.querySelector('.search-form [name="make"]').value==='') {
      loadManufacturers(searchType);
      loadBodyTypes(searchType);
    } else if(document.querySelector('.search-form [name="make"]').value!=='' && document.querySelector('.search-form [name="model"]').value==='') {
      loadModels(searchType, document.querySelector('.search-form [name="make"]').value);
      loadSpecs(document.querySelector('#search-type').value, document.querySelector('.search-form [name=model]').value);
      loadBodyTypes(searchType);
    }

    document.querySelector('.search-form [name=make]').addEventListener("change", function (e) {
      let searchType = document.querySelector('#search-type').value;
      loadModels(searchType, e.target.value);
      loadSpecs(searchType);
      loadBodyTypes(searchType);
    });

    document.querySelector('.search-form [name=model]').addEventListener("change", function (e) {
      let searchType = document.querySelector('#search-type').value;
      loadSpecs(searchType, e.target.value);
      loadBodyTypes(searchType);
    });

    const searchSorter = document.querySelector('#sortBy');
    if (searchSorter) {
      searchSorter.addEventListener('change', (e) => {
        const urlParams = new URLSearchParams(window.location.search);
        urlParams.set('order', e.target.value);
        if (
            (e.target.value === 'price_asc' || e.target.value === 'price_desc') &&
            (!window.location.search.includes('initial_profile') || urlParams.get('initial_profile') === '')
        ) {
          urlParams.set('initial_profile', e.target.dataset.profile);
        }
        window.location.search = urlParams;
      })
    }
  }
}


setTimeout(function(){
  // Preloader
  document.querySelector('html').classList.add("site-loaded");
  document.body.classList.add("loaded");
  // END Preloader
}, 3000);
document.addEventListener("DOMContentLoaded", function() {
  // Preloader
  document.querySelector('html').classList.add("site-loaded");
  document.body.classList.add("loaded");
  // END Preloader
});
document.onload = (function(){
  // Preloader
  document.querySelector('html').classList.add("site-loaded");
  document.body.classList.add("loaded");
  // END Preloader
});
window.onload = (function(){
  // Preloader
  document.querySelector('html').classList.add("site-loaded");
  document.body.classList.add("loaded");
  // END Preloader
  loadSearchForm();
});

document.addEventListener('DOMContentLoaded', () => {
  // Testimonial Logos
  if (document.querySelector('.testimonials-grid:not(.testimonials-grid-single)')) {
    const interval = setInterval(function() {
      document.querySelectorAll('.testimonials-grid:not(.testimonials-grid-single) .testimonials-grid-item img').forEach((v) => { v.classList.add('animate')});
      setTimeout(function(){
        document.querySelector('.testimonials-grid:not(.testimonials-grid-single)').insertAdjacentElement('afterbegin', document.querySelector('.testimonials-grid:not(.testimonials-grid-single) .testimonials-grid-item:last-child'));
      },200);
      setTimeout(function(){
        document.querySelectorAll('.testimonials-grid:not(.testimonials-grid-single) .testimonials-grid-item img').forEach((v) => { v.classList.remove('animate')});
      },500);
    }, 7000);
  }

  //Lazy Load Images
  let lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));
  let active = false;
  const lazyLoad = function() {
    if (active === false) {
      active = true;

      lazyImages.forEach(function(lazyImage) {
        if ((lazyImage.getBoundingClientRect().top <= window.innerHeight && lazyImage.getBoundingClientRect().bottom >= 0) && getComputedStyle(lazyImage).display !== "none") {
          lazyImage.src = lazyImage.dataset.src;
          // lazyImage.srcset = lazyImage.dataset.srcset;
          lazyImage.classList.remove("lazy");

          lazyImages = lazyImages.filter(function(image) {
            return image !== lazyImage;
          });

          if (lazyImages.length === 0) {
            document.removeEventListener("scroll", lazyLoad);
            window.removeEventListener("resize", lazyLoad);
            window.removeEventListener("orientationchange", lazyLoad);
          }
        }
      });

      active = false;
    }
  };
  document.addEventListener("scroll", lazyLoad);
  window.addEventListener("resize", lazyLoad);
  window.addEventListener("orientationchange", lazyLoad);
  lazyLoad();

  // Deal Box Slider
  const dealBoxSlider = [].slice.call(document.querySelectorAll('.offers-strip:not(.derivative-page) .offers-strip-ctr'))
  if (dealBoxSlider) {
    dealBoxSlider.forEach((e) => {
      let sliderID = e.parentElement.parentElement.getAttribute('id')
      new Glider(e, {
        slidesToScroll: 1,
        slidesToShow: 1,
        draggable: true,
        scrollLock: true,
        arrows: {
          prev: '.offers-strip#'+sliderID+' .glider-prev',
          next: '.offers-strip#'+sliderID+' .glider-next'
        },
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
            }
          }
        ]
      })
    })
  }

  // Derivative Deal Box Slider
  const derivativeSlider = document.querySelector('.offers-strip-derivative .offers-strip-ctr');
  if (derivativeSlider) {
    const glider = new Glider(derivativeSlider, {
      slidesToScroll: 1,
      slidesToShow: 1,
      draggable: true,
      scrollLock: true,
      arrows: {
        prev: '.offers-strip-derivative .glider-prev',
        next: '.offers-strip-derivative .glider-next'
      },
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 3,
          }
        }
      ]
    })
  }

  // Blog Slider
  const blogSlider = [].slice.call(document.querySelectorAll('.blog-strip-grid'))
  if (blogSlider) {
    blogSlider.forEach((e) => {
      new Glider(e, {
        slidesToScroll: 1,
        slidesToShow: 1,
        draggable: true,
        scrollLock: true,
        arrows: {
          prev: '.blog-list-strip .glider-prev',
          next: '.blog-list-strip .glider-next'
        },
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
            }
          }
        ]
      })
    })
  }

  // Reviews Slider
  const reviewsSlider = document.querySelector('.reviews-wrapper');
  if (reviewsSlider) {
    const glider = new Glider(reviewsSlider, {
      slidesToScroll: 1,
      slidesToShow: 1,
      scrollLock: true,
      rewind: true,
      draggable: true,
      dots: '#dots'
    });
    sliderAuto(glider, 8000);
  }

  // Featured Ranges Slider
  const sidebarSlider = document.querySelector('#sidebar-offers .sidebar-offers-track');
  if (sidebarSlider) {
    const glider = new Glider(sidebarSlider, {
      slidesToScroll: 1,
      slidesToShow: 1,
      draggable: true,
      scrollLock: true,
      arrows: {
        prev: '.sidebar-offers-arrows .glider-prev',
        next: '.sidebar-offers-arrows .glider-next'
      },
      responsive: [
      {
        breakpoint: 769,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 1100,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
    })
    sliderAuto(glider, 20000);
  }

  // Manufacturers Slider
  const partnersSlider = document.querySelector('.partner-logos ul');
  if (partnersSlider) {
    const gliderPartners = new Glider(partnersSlider, {
      slidesToScroll: 1,
      slidesToShow: 1.5,
      scrollLock: false,
      rewind: true,
      draggable: true,
      responsive: [
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 6,
          }
        }
      ]
    });
    sliderAuto(gliderPartners, 3000);
  }

  // Campers Gallery Slider
  const campersSlider = document.querySelector('.section-gallery-inner');
  if (campersSlider) {
    const gliderCampers = new Glider(campersSlider, {
      slidesToScroll: 1,
      slidesToShow: 2,
      scrollLock: false,
      rewind: true,
      draggable: true,
      arrows: {
        prev: '.section-gallery-controls .glider-prev',
        next: '.section-gallery-controls .glider-next'
      },
      responsive: [
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 5,
          }
        }
      ]
    });
    sliderAuto(gliderCampers, 3000);
  }

  // Derivative Gallery Slider
  const dealGallerySlider = document.querySelector('.deal-gallery-track');
  if (dealGallerySlider) {
    new Glider(dealGallerySlider, {
      slidesToScroll: 1,
      slidesToShow: 1,
      draggable: true,
      scrollLock: true,
      arrows: {
        prev: '.deal-gallery-controls .glider-prev',
        next: '.deal-gallery-controls .glider-next'
      },
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 1900,
          settings: {
            slidesToShow: 5,
          }
        }
      ]
    })
  }

  // Auto-slide helper function
  function sliderAuto(slider, milliseconds) {
    const slidesCount = slider.track.childElementCount;
    let slideTimeout = null;
    let nextIndex = 1;

    function slide() {
      slideTimeout = setTimeout(
        function () {
          if (nextIndex >= slidesCount ) {
            nextIndex = 0;
          }
          slider.scrollItem(nextIndex++);
        },
        milliseconds
      );
    }

    slider.ele.addEventListener('glider-animated', function() {
      window.clearInterval(slideTimeout);
      slide();
    });

    slide();
  }

// Toggle class for accordions
  let acc = document.getElementsByClassName('mobile-accordion-header');
  for (let i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function(ev) {

      for (let i = 0; i < acc.length; i++) {
        if (acc[i] === this || acc[i].parentElement.parentElement !== this.parentElement.parentElement || this.parentElement.classList.contains('no-close')) {
          continue;
        }
        acc[i].parentElement.classList.remove('active');
      }

      if (!this.parentElement.classList.contains('active') && !this.parentElement.classList.contains('no-scroll')){
        setTimeout(() => { document.documentElement.scrollTop += this.getBoundingClientRect().top; }, 500);
      }
      this.parentElement.classList.toggle("active");

    });
  }

  // Close modals on orientation changes
  window.addEventListener("orientationchange", function() {
    modalMobileNav.close();
    hamburger.classList.remove('active');
    hamburger.classList.remove('is-active');
    navContainer.classList.remove('is-active');
    // navbar.classList.remove('is-sticky');
    // tingleModal.classList.remove('is-sticky');
  }, false);

  // Table Sorting
  // function sortTable(elem) {
  //   let sortName = elem.composedPath()[0].dataset.sortname;
  //   let sortDirection = elem.composedPath()[0].dataset.sortdirection;
  //   let tableBody = elem.composedPath()[3].childNodes[3];
  //   let tableRows = Array.from(tableBody.children);
  //
  //   let sortRows = (dir) => [...tableRows].filter(row => (sortName !== 'price' && row.dataset[sortName].length) || (sortName === 'price' && row.dataset.price !== 'POA')).sort(function (a, b) {
  //     a = a.dataset[sortName];
  //     b = b.dataset[sortName];
  //     return (dir === 'asc') ? b.localeCompare(a) : a.localeCompare(b);
  //   });
  //
  //   if (sortDirection.length && sortDirection === 'asc') {
  //     [].slice.call(document.querySelectorAll('.table-sort')).forEach((el) => el.setAttribute('data-sortdirection', ''));
  //     elem.composedPath()[0].setAttribute('data-sortdirection', 'desc');
  //     let sortTable = sortRows('desc').forEach(function (value) {
  //       value.remove();
  //       tableBody.prepend(value);
  //     });
  //   } else {
  //     [].slice.call(document.querySelectorAll('.table-sort')).forEach((el) => el.setAttribute('data-sortdirection', ''));
  //     elem.composedPath()[0].setAttribute('data-sortdirection', 'asc');
  //     let sortTable = sortRows('asc').forEach(function (value) {
  //       value.remove();
  //       tableBody.prepend(value);
  //     });
  //   }
  // }

  // Sort Model Table
  //let sortHeaders = document.querySelectorAll('#model-table .model-table-head .table-sort[data-sortName]');
  //[...sortHeaders].forEach((value) => value.addEventListener('click', (val) => sortTable(val)));

  // Fix Model Table Filter on Back Button
  setTimeout(() => { document.querySelectorAll('#model-table select').forEach(v => { v.dispatchEvent(new Event('change')) }) }, 800)


  // Header - Show More
  const showMoreButton = document.querySelector('#show-more');
  if(showMoreButton){
    if (showMoreButton.parentElement.querySelectorAll('.header-description > p').length > 1) {
      showMoreButton.addEventListener('click', (e) => {
        e.target.parentElement.classList.add('header-content--full');
      })
    } else {
      showMoreButton.parentElement.classList.add('header-content--full');
    }
  }

// Advanced Search
  document.getElementById('toggleAdvanced') ? document.getElementById('toggleAdvanced').addEventListener('click', function(e){
    e.preventDefault();
    document.querySelector('.form select[name="budget"]').selectedIndex = 0;
    document.querySelector('.quick-search').classList.toggle('search-advanced');
  }) : null;


  // Contact Form
  if(document.getElementById('send-contact-form')){
    // Do captcha and submit form

    let button = document.querySelector('#send-contact-form');
    let terms = document.querySelector('#contact-form [name=consent]');
    if(terms){
      terms.onchange = function() {
        button.disabled = !this.checked;
      };
    }

    document.getElementById('send-contact-form').addEventListener("click", function(e) {
      e.preventDefault();

      document.body.classList.remove('loaded');
      button.disabled = true;
      button.innerHTML = 'Sending...';

      grecaptcha.ready(function() {
        grecaptcha.execute(document.getElementById('contact-form').dataset['recaptcha'], {action: 'contact'}).then(function(recaptcha_token) {
          document.querySelector('input[name=g-recaptcha-response]').value = recaptcha_token;

          let url = '/contact';
          let email = document.querySelector('#contact-form [name=email]').value;
          let name = document.querySelector('#contact-form [name=name]').value;
          let company = document.querySelector('#contact-form [name=company]').value;
          // let surname = document.querySelector('#contact-form [name=surname]').value;
          let telephone = document.querySelector('#contact-form [name=telephone]').value;
          let comments = document.querySelector('#contact-form [name=comments]').value;
          let csrf_token = document.querySelector('#contact-form [name=_token]').value;
          let deal_type = document.querySelector('#contact-form [name=deal_type]').value;

          if(company != ''){
            deal_type = 'Business - Contract Hire';
          }

          fetch(url, {
            method: 'POST',
            body: JSON.stringify({
              'name': name,
              // 'forename': forename,
              'company': company,
              'email': email,
              'telephone': telephone,
              'comments': comments,
              '_token': csrf_token,
              'deal_type': deal_type,
              'g-recaptcha-response': recaptcha_token
            }),
            headers:{
              'Content-Type': 'application/json'
            }}).then(function(response) {
            document.body.classList.add('loaded');
            button.disabled = false;
            button.innerHTML = 'Submit Enquiry';
            if (response.status !== 200) {
              console.warn('Looks like there was a problem. Status Code: ' +
                  response.status);
              return;
            }
            return response.json();
          }).then(function(data) {
            if(data.status !== 'ok'){
              let errors = '';
              for (var i in data.errors) {
                errors += data.errors[i][0]+'\n';
              }
              button.disabled = false;
              button.innerHTML = 'Submit Enquiry';
              return alert('There was a problem with your form\n\n'+errors);
            }

            button.disabled = false;
            button.innerHTML = 'Submit Enquiry';
            document.getElementsByClassName('contact-form')[0].reset();
            document.getElementsByClassName('contact-content')[0].classList.add('hidden');
            document.getElementsByClassName('thank-you')[0].classList.remove('hidden');
            document.getElementsByClassName('contact-details-form')[0].scrollIntoView();

            // Trigger event tracking
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              'event': 'General Enquiry Received'
            });


          }).catch(function(err) {
            document.body.classList.add('loaded');
            console.error('Fetch Error -', err);
            return alert('There was a problem sending your enquiry. Please call us or use our general contact email address.');
          });

        });
      });

    });
  }
  // END Contact Form


  // Calculators
  if (document.querySelector('body').classList.contains('page-tools') && document.querySelector('.tools-main>div')) {
    function numberWithCommas(x) {
      if (x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
    }
    // Next Step
    document.querySelectorAll('.next-step').forEach((value) => {
      value.addEventListener('click', (e) => {
        document.querySelectorAll('.step').forEach((value) => { value.classList.remove('active') })
        value.parentElement.parentElement.nextElementSibling.classList.add('active')
        window.scrollTo({ top: 0, behavior: 'smooth' });
      })
    })
    // Back Step
    document.querySelectorAll('.back-step').forEach((value) => {
      value.addEventListener('click', (e) => {
        document.querySelectorAll('.step').forEach((value) => { value.classList.remove('active') })
        value.parentElement.parentElement.previousElementSibling.classList.add('active')
        window.scrollTo({ top: 0, behavior: 'smooth' });
      })
    })
    // Steps Progress Bar
    document.querySelectorAll('.next-step, .back-step').forEach((value) => {
      value.addEventListener('click', (e) => {
        let percent = value.dataset.percent;
        if (document.querySelector('#progress-bar')){
          document.querySelector('#progress-bar').classList.add(`step-${percent}`);
        }
      })
    })
    // Indicative Fuel Cost
    function indicativeCost($fuel_type = false, $mpg = null, $electric_range = null, $battery_size = null, $electricity_cost = null) {
      let indicativeCost;
      if ($fuel_type === 'Electric' && $electric_range && $battery_size){
        let electricity_cost = ($electricity_cost) ? $electricity_cost : document.getElementById('average-data').dataset.averageElectricity;
        let miles_per_kwh = $electric_range / $battery_size;
        let cost_per_mile = electricity_cost / miles_per_kwh;
        indicativeCost = cost_per_mile.toFixed(1);
      } else if ($fuel_type === 'Diesel' && $mpg) {
        let cost_per_litre_input = document.getElementById('price-fuel-field');
        let cost_per_litre_diesel;
        if (cost_per_litre_input) {
          cost_per_litre_diesel = parseFloat(cost_per_litre_input.value) * 100;
        } else {
          cost_per_litre_diesel = document.getElementById('average-data').dataset.averageDiesel;
        }
        let miles_per_litre = $mpg / 4.54609;
        let cost_per_mile = cost_per_litre_diesel / miles_per_litre;
        indicativeCost = cost_per_mile.toFixed(1);
      } else if ($fuel_type !== false && $mpg) {
        let cost_per_litre_input = document.getElementById('price-fuel-field');
        let cost_per_litre_petrol;
        if (cost_per_litre_input) {
          cost_per_litre_petrol = parseFloat(cost_per_litre_input.value) * 100;
        } else {
          cost_per_litre_petrol = document.getElementById('average-data').dataset.averagePetrol;
        }
        let miles_per_litre = $mpg / 4.54609;
        let cost_per_mile = cost_per_litre_petrol / miles_per_litre;
        indicativeCost = cost_per_mile.toFixed(1);
      } else {
        indicativeCost = 'N/A';
      }
      return indicativeCost;
    }

    function equalHeight($el_1, $el_2) {
      let leftHeight = $el_1.clientHeight;
      let rightHeight = $el_2.clientHeight;
      $el_1.setAttribute('style', '');
      $el_2.setAttribute('style', '');
      setTimeout(() => {
        if (leftHeight > rightHeight) {
          $el_1.style.height=(leftHeight+5)+'px';
          $el_2.style.height=(leftHeight+5)+'px';
        }
        if (leftHeight < rightHeight) {
          $el_1.style.height=(rightHeight+5)+'px';
          $el_2.style.height=(rightHeight+5)+'px';
        }
      }, 500);
    }
    // Load Manufacturers Dropdown
    function loadManufacturersCalc($type, $ev = true, $el = '[name="calculator-make"]') {
      let make_dropdowns = document.querySelectorAll($el);
      for (i = 0; i < make_dropdowns.length; i++) {
        var dropdown = make_dropdowns[0];
        dropdown.length = 0;

        let defaultOption = document.createElement('option');
        defaultOption.text = 'Choose Make';
        defaultOption.value = '';

        dropdown.add(defaultOption);
        dropdown.selectedIndex = 0;

        let url;
        ($ev) ? url = '/api/' + $type + '/manufacturers/ev' : url = '/api/' + $type + '/manufacturers';

        fetch(url).then(function(response) {
          if (response.status !== 200) {
            console.warn('Looks like there was a problem. Status Code: ' +
                response.status);
            return;
          }
          return response.json();
        }).then(function(data) {
          let keysSorted = Object.keys(data).sort(function(a, b) {
            return data[a].localeCompare(data[b])
          });
          for (let x in keysSorted) {
            let option = document.createElement('option');
            option.text = data[keysSorted[x]];
            option.value = keysSorted[x];
            dropdown.add(option);
          }
        }).catch(function(err) {
          console.error('Fetch Error -', err);
        });
      }
    }
    // Load Models Dropdown
    function loadModelsCalc($type, $manufacturer, $ev = true, $inactive = false, $compare = false) {
      let model_dropdowns, derivative_dropdowns;
      ($compare) ? model_dropdowns = document.getElementsByName("calculator-model-compare") : model_dropdowns = document.getElementsByName("calculator-model");
      ($compare) ? derivative_dropdowns = document.getElementsByName("calculator-derivative-compare") : derivative_dropdowns = document.getElementsByName("calculator-derivative");
      for (let i = 0; i < derivative_dropdowns.length; i++) {
        let dropdown = derivative_dropdowns[i];
        dropdown.length = 0;
        let defaultOption = document.createElement('option');
        defaultOption.text = 'Choose Variant';
        defaultOption.value = '';
        dropdown.add(defaultOption);
        dropdown.selectedIndex = 0;
      }
      for (let i = 0; i < model_dropdowns.length; i++) {
        let dropdown = model_dropdowns[i];
        dropdown.length = 0;

        let defaultOption = document.createElement('option');
        defaultOption.text = 'Choose Model';
        defaultOption.value = '';

        dropdown.add(defaultOption);
        dropdown.selectedIndex = 0;

        let url;
        ($ev) ? url = '/api/' + $type + '/models/' + $manufacturer + '/ev' : url = '/api/' + $type + '/models/' + $manufacturer;

        let params;
        ($inactive) ? params = '?' + new URLSearchParams({'inc': 'inactive'}) : params = '';

        fetch(url + params).then(function(response) {
          if (response.status !== 200) {
            console.warn('Looks like there was a problem. Status Code: ' +
                response.status);
            return;
          }
          return response.json();
        }).then(function(data) {
          let keysSorted = Object.keys(data).sort(function(a, b) {
            return data[a].localeCompare(data[b])
          });
          for (let x in keysSorted) {
            let option = document.createElement('option');
            option.text = data[keysSorted[x]];
            option.value = keysSorted[x];
            dropdown.add(option);
          }
        }).catch(function(err) {
          console.error('Fetch Error -', err);
        });
      }
    }
    // Load Derivatives Dropdown
    function loadDerivativeCalc($type, $model, $default = false, $ev = true, $inactive = false, $compare = false, $distinct = true, $non_ev = false) {
      let derivative_dropdowns;
      ($compare) ? derivative_dropdowns = document.getElementsByName("calculator-derivative-compare") : derivative_dropdowns = document.getElementsByName("calculator-derivative");
      for (let i = 0; i < derivative_dropdowns.length; i++) {
        let dropdown = derivative_dropdowns[i];
        dropdown.length = 0;

        if ($default){
          let defaultOption = document.createElement('option');
          defaultOption.text = 'Choose Variant';
          defaultOption.value = '';

          dropdown.add(defaultOption);
          dropdown.selectedIndex = 0;
        }

        let url;
        ($ev) ? url = '/api/' + $type + '/derivatives/' + $model + '/ev' : url = '/api/' + $type + '/derivatives/' + $model + ($non_ev ? '/nonev' : '');

        let params;
        if($compare) {
          ($inactive) ? params = '?' + new URLSearchParams({'inc': 'inactive', 'compare_ev': 'true'}) : params = '?' + new URLSearchParams({'has_deals': 'true'});
        } else {
          ($inactive) ? params = '?' + new URLSearchParams({'inc': 'inactive'}) : params = '?' + new URLSearchParams({'has_deals': 'true'});
        }

        fetch(url + params).then(function(response) {
          if (response.status !== 200) {
            console.warn('Looks like there was a problem. Status Code: ' +
                response.status);
            return;
          }
          return response.json();
        }).then(function(data) {

          if ($distinct) {
            let distinct = []
            for (const key in data) {
              if (!distinct.includes(data[key])) {
                distinct.push(data[key]);
              } else {
                delete data[key];
              }
            }
          }

          let keysSorted = Object.keys(data).sort(function(a, b) {
            return data[a].localeCompare(data[b])
          });
          for (let x in keysSorted) {
            if (x === '2813'){ continue }
            let option = document.createElement('option');
            option.text = data[keysSorted[x]];
            option.value = keysSorted[x];
            dropdown.add(option);
          }
        }).catch(function(err) {
          console.error('Fetch Error -', err);
        });
      }
    }

    // Compare Cars
    if (document.querySelector('.tools-main>div').classList.contains('car-comparison')) {
      let comparisonTable = document.getElementById('car-comparison')
      let makeField = document.querySelector('.form-first select[name=calculator-make]')
      let modelField = document.querySelector('.form-first select[name=calculator-model]')
      let derivativeField = document.querySelector('.form-first select[name=calculator-derivative]')
      let makeField2 = document.querySelector('.form-second select[name=calculator-make]')
      let modelField2 = document.querySelector('.form-second select[name=calculator-model]')
      let derivativeField2 = document.querySelector('.form-second select[name=calculator-derivative]')
      loadManufacturersCalc('car', true, '.form-first select[name=calculator-make]');
      loadManufacturersCalc('car', true, '.form-second select[name=calculator-make]');

      makeField2.addEventListener('change', e => {
        makeField.selectedIndex = makeField2.selectedIndex;
        makeField.dispatchEvent(new Event('change'));
      })
      modelField2.addEventListener('change', e => {
        modelField.selectedIndex = modelField2.selectedIndex;
        modelField.dispatchEvent(new Event('change'));
      })
      derivativeField2.addEventListener('change', e => {
        derivativeField.selectedIndex = derivativeField2.selectedIndex;
        derivativeField.dispatchEvent(new Event('change'));
      })

      function compareColumns(row, reverse = false, blue = false) {
        let largest = 0
        let smallest = 9999
        comparisonTable.querySelectorAll(`[data-cell-content="${row}"] [data-car][data-compare]`).forEach((value, key, parent) => {
          if (comparisonTable.querySelectorAll(`[data-cell-content="${row}"] [data-car][data-compare]`).length > 1) {
            (largest < parseInt(value.getAttribute('data-compare'))) ? largest = value.getAttribute('data-compare') : '';
            (smallest > parseInt(value.getAttribute('data-compare'))) ? smallest = value.getAttribute('data-compare'): '';
            comparisonTable.querySelectorAll(`[data-cell-content="${row}"] [data-car][data-compare]`).forEach((v) => {v.setAttribute('data-highlight', '')});
            if(largest !== smallest) {
              comparisonTable.querySelectorAll(`[data-cell-content="${row}"] [data-car][data-compare='${largest}']`).forEach((v) => {v.setAttribute('data-highlight', `up-${(blue) ? 'blue' : ((reverse) ? 'red' : 'green')}`)})
              comparisonTable.querySelectorAll(`[data-cell-content="${row}"] [data-car][data-compare='${smallest}']`).forEach((v) => {v.setAttribute('data-highlight', `down-${(blue) ? 'blue' : ((reverse) ? 'green' : 'red')}`)})
            }
          }
        })
      }

      function loadPrice($spot, $derivative) {
        comparisonTable.querySelector(`[data-cell-content="initial-profile"] [data-car=first] span`).innerText = document.querySelector('.quote-terms[name=profile]').options[document.querySelector('.quote-terms[name=profile]').selectedIndex].text;
        comparisonTable.querySelector(`[data-cell-content="initial-profile"] [data-car=second] span`).innerText = document.querySelector('.quote-terms[name=profile]').options[document.querySelector('.quote-terms[name=profile]').selectedIndex].text;
        comparisonTable.querySelector(`[data-cell-content="initial-profile"] [data-car=third] span`).innerText = document.querySelector('.quote-terms[name=profile]').options[document.querySelector('.quote-terms[name=profile]').selectedIndex].text;
        comparisonTable.querySelector(`[data-cell-content="contract-length"] [data-car=first] span`).innerText = document.querySelector('.quote-terms[name=term]').options[document.querySelector('.quote-terms[name=term]').selectedIndex].text;
        comparisonTable.querySelector(`[data-cell-content="contract-length"] [data-car=second] span`).innerText = document.querySelector('.quote-terms[name=term]').options[document.querySelector('.quote-terms[name=term]').selectedIndex].text;
        comparisonTable.querySelector(`[data-cell-content="contract-length"] [data-car=third] span`).innerText = document.querySelector('.quote-terms[name=term]').options[document.querySelector('.quote-terms[name=term]').selectedIndex].text;
        comparisonTable.querySelector(`[data-cell-content="annual-mileage"] [data-car=first] span`).innerText = document.querySelector('.quote-terms[name=mileage]').options[document.querySelector('.quote-terms[name=mileage]').selectedIndex].text;
        comparisonTable.querySelector(`[data-cell-content="annual-mileage"] [data-car=second] span`).innerText = document.querySelector('.quote-terms[name=mileage]').options[document.querySelector('.quote-terms[name=mileage]').selectedIndex].text;
        comparisonTable.querySelector(`[data-cell-content="annual-mileage"] [data-car=third] span`).innerText = document.querySelector('.quote-terms[name=mileage]').options[document.querySelector('.quote-terms[name=mileage]').selectedIndex].text;
        comparisonTable.querySelector(`[data-cell-content="price"] [data-car=${$spot}] span`).innerText = 'Loading...';

        document.querySelector('input[name="car_id"]').value = $derivative;
        let url = '/api/car/price/' + $derivative;
        let formData = new FormData(document.getElementById('car-comparison'));
        fetch(url, {
          method: 'POST',
          body: formData,
        }).then(function (response) {
          if (response.status !== 200) {
            console.warn('Looks like there was a problem. Status Code: ' + response.status);
            return;
          }
          return response.json();
        }).then(function (data) {
          if (data) {
            comparisonTable.querySelector(`[data-cell-content="price"] [data-car=${$spot}] span`).innerText = (data.monthly_rental != null) ? '£' + numberWithCommas(parseFloat(data.monthly_rental).toFixed(2)) : 'N/A';
            (data.monthly_rental != null) ? comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] a.view-range-button`).classList.remove('visually-hidden') : comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] a.view-range-button`).classList.add('visually-hidden');
            (data.monthly_rental != null) ? comparisonTable.querySelector(`[data-cell-content="cta"] [data-car=${$spot}] a.view-range-button`).classList.remove('visually-hidden') : comparisonTable.querySelector(`[data-cell-content="cta"] [data-car=${$spot}] a.view-range-button`).classList.add('visually-hidden');
            (parseInt(data.monthly_rental) >= 0) ? comparisonTable.querySelector(`[data-cell-content="price"] [data-car=${$spot}]`).setAttribute('data-compare', data.monthly_rental) : '';
            compareColumns('price', true);
            // comparisonTable.querySelector(`[data-cell-content="contract-length"] [data-car=${$spot}] span`).innerText = (data.term != null) ? data.term + ' months' : 'N/A';
            // (parseInt(data.term) >= 0) ? comparisonTable.querySelector(`[data-cell-content="contract-length"] [data-car=${$spot}]`).setAttribute('data-compare', data.term) : '';
            // comparisonTable.querySelector(`[data-cell-content="initial-profile"] [data-car=${$spot}] span`).innerText = (data.initial_profile != null) ? data.initial_profile + ' months' : 'N/A';
            // (parseInt(data.initial_profile) >= 0) ? comparisonTable.querySelector(`[data-cell-content="initial-profile"] [data-car=${$spot}]`).setAttribute('data-compare', data.initial_profile) : '';
            // comparisonTable.querySelector(`[data-cell-content="annual-mileage"] [data-car=${$spot}] span`).innerText = (data.mileage != null) ? data.mileage + ' miles' : 'N/A';
            // (parseInt(data.mileage) >= 0) ? comparisonTable.querySelector(`[data-cell-content="annual-mileage"] [data-car=${$spot}]`).setAttribute('data-compare', data.mileage) : '';
          }
        }).catch(function (err) {
          console.error('Fetch Error -', err);
          document.getElementsByClassName('price')[0].classList.remove('hidden');
          document.getElementsByClassName('price-fetching')[0].classList.add('hidden');
        });
      }

      function setLinks($spot, $active, $url, $fuel) {
        let params = '?' + new URLSearchParams({
          'term': document.querySelector('.quote-terms[name=term]').options[document.querySelector('.quote-terms[name=term]').selectedIndex].value,
          'profile': document.querySelector('.quote-terms[name=profile]').options[document.querySelector('.quote-terms[name=profile]').selectedIndex].value,
          'mileage': document.querySelector('.quote-terms[name=mileage]').options[document.querySelector('.quote-terms[name=mileage]').selectedIndex].value
        });
        ($active == '1') ? comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] a.view-range-button`).setAttribute('href', $url + params) : comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] a.view-range-button`).classList.add('visually-hidden');
        ($active == '1') ? comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] a.view-range-button`).setAttribute('href', $url + params) : comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] a.view-range-button`).classList.add('visually-hidden');
        ($active == '1') ? comparisonTable.querySelector(`[data-cell-content="cta"] [data-car=${$spot}] a.view-range-button`).setAttribute('href', $url + params) : comparisonTable.querySelector(`[data-cell-content="cta"] [data-car=${$spot}] a.view-range-button`).classList.add('visually-hidden');
      }

      function loadVehicle($spot, $derivative) {
        if ($derivative !== 0) {
          let url = '/api/car/' + $derivative;
          let params = '?' + new URLSearchParams({'type': (document.querySelector('#car-comparison input[name=type]')).value});
          fetch(url + params).then(function(response) {
            if (response.status !== 200) {
              console.warn('Looks like there was a problem. Status Code: ' + response.status);
              return;
            }
            return response.json();
          }).then(function(data) {
            let getCapTechnicalData;
            if(data.car.technical) {
              getCapTechnicalData = ($category, $term) => (data.car.technical[$category] !== undefined) ? (data.car.technical[$category].find(item => item.name.includes($term))) : false;
            } else {
              getCapTechnicalData = ($category, $term) => 'N/A';
            }
            comparisonTable.setAttribute(`data-car-${$spot}`, $derivative);

            comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] .make`).innerText = data.car.range_name;
            comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] .derivative`).innerText = data.car.name;

            (data.car.active == '1') ? comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] a.view-range-button`).setAttribute('href', data.car.full_url) : comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] a.view-range-button`).classList.add('visually-hidden');
            (data.car.active == '1') ? comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] a.view-range-button`).setAttribute('href', data.car.full_url) : comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] a.view-range-button`).classList.add('visually-hidden');

            comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] img`).setAttribute('onerror', `this.src="${data.car.main_img}"`);
            data.car.main_img.includes('std/') ? comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] img`).setAttribute('src', data.car.main_img.replace('std/', 'big/')) : comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] img`).setAttribute('src', data.car.main_img);

            setLinks($spot, data.car.active, data.car.full_url, data.car.fuel_type);

            comparisonTable.querySelector(`[data-cell-content="fuel-type"] [data-car=${$spot}] span`).innerText = (data.car.fuel_type) ? data.car.fuel_type : 'N/A';
            comparisonTable.querySelector(`[data-cell-content="p11d"] [data-car=${$spot}] span`).innerText = (data.car.base_price) ? '£' + numberWithCommas((parseFloat(data.car.base_price)).toFixed(0)) : 'N/A';
            comparisonTable.querySelector(`[data-cell-content="electric-range"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Electric Vehicle Data', 'Pure Electric Range (miles) - Comb - Min') && getCapTechnicalData('Electric Vehicle Data', 'Pure Electric Range (miles) - Comb - Min').value) ? getCapTechnicalData('Electric Vehicle Data', 'Pure Electric Range (miles) - Comb - Min').value + ' miles' : ((data.car.electric_range) ? data.car.electric_range + ' miles' : 'N/A');
            (getCapTechnicalData('Electric Vehicle Data', 'Pure Electric Range (miles) - Comb - Min') && getCapTechnicalData('Electric Vehicle Data', 'Pure Electric Range (miles) - Comb - Min').value) ? comparisonTable.querySelector(`[data-cell-content="electric-range"] [data-car=${$spot}]`).setAttribute('data-compare', getCapTechnicalData('Electric Vehicle Data', 'Pure Electric Range (miles) - Comb - Min').value) : comparisonTable.querySelector(`[data-cell-content="electric-range"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.electric_range);
            compareColumns('electric-range');
            comparisonTable.querySelector(`[data-cell-content="real-electric-range"] [data-car=${$spot}] span`).innerText = (data.car.electric_range_real_world) ? data.car.electric_range_real_world + ' miles' : 'N/A';
            (parseInt(data.car.electric_range_real_world) > 0) ? comparisonTable.querySelector(`[data-cell-content="real-electric-range"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.electric_range_real_world) : '';
            compareColumns('real-electric-range');

            comparisonTable.querySelector(`[data-cell-content="official-mpg"] [data-car=${$spot}] span`).innerText = (data.car.mpg_combined && parseInt(data.car.mpg_combined) > 0) ? data.car.mpg_combined + ' mpg' : 'N/A';
            (parseInt(data.car.mpg_combined) > 0) ? comparisonTable.querySelector(`[data-cell-content="official-mpg"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.mpg_combined) : '';
            compareColumns('official-mpg');
            comparisonTable.querySelector(`[data-cell-content="real-mpg"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Fuel Consumption - ICE', 'WLTP - MPG - Comb - Max') && getCapTechnicalData('Fuel Consumption - ICE', 'WLTP - MPG - Comb - Max').value) ? getCapTechnicalData('Fuel Consumption - ICE', 'WLTP - MPG - Comb - Max').value + ' mpg' : 'N/A';
            (getCapTechnicalData('Fuel Consumption - ICE', 'WLTP - MPG - Comb - Max')) ? comparisonTable.querySelector(`[data-cell-content="real-mpg"] [data-car=${$spot}]`).setAttribute('data-compare', getCapTechnicalData('Fuel Consumption - ICE', 'WLTP - MPG - Comb - Max').value) : '';
            compareColumns('real-mpg');

            let indicative_fuel_cost = indicativeCost(data.car.fuel_type, (data.car.mpg_combined != null) ? data.car.mpg_combined : ((data.car.mpg_urban != null) ? data.car.mpg_urban : data.car.mpg_extra), (data.car.electric_range != null) ? data.car.electric_range : null, data.car.battery_capacity);
            comparisonTable.querySelector(`[data-cell-content="indicative-cost"] [data-car=${$spot}] span`).innerText = (parseInt(indicative_fuel_cost) >= 0) ? indicative_fuel_cost + ' p/mile' : 'N/A';
            (parseInt(indicative_fuel_cost) >= 0) ? comparisonTable.querySelector(`[data-cell-content="indicative-cost"] [data-car=${$spot}]`).setAttribute('data-compare', indicative_fuel_cost) : '';
            compareColumns('indicative-cost', true);

            // comparisonTable.querySelector(`[data-cell-content="green-car-rating"] [data-car=${$spot}] span`).innerText = 'N/A';
            // comparisonTable.querySelector(`[data-cell-content="climate-air"] [data-car=${$spot}] span`).innerText = 'N/A';getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions')
            comparisonTable.querySelector(`[data-cell-content="co2-emissions"] [data-car=${$spot}] span`).innerText = (data.car.co2) ? parseInt(data.car.co2).toFixed(0) + ' g/km' : 'N/A';
            comparisonTable.querySelector(`[data-cell-content="euro-standard"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions') && getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions').value) ? getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions').value : 'N/A';
            // comparisonTable.querySelector(`[data-cell-content="nox"] [data-car=${$spot}] span .nox`).innerText = (getCapTechnicalData('Emissions - ICE', 'NOx')) ? getCapTechnicalData('Emissions - ICE', 'NOx').value : 'Not Available';
            // comparisonTable.querySelector(`[data-cell-content="nox"] [data-car=${$spot}] span .particles`).innerText = (getCapTechnicalData('Emissions - ICE', 'Particles')) ? getCapTechnicalData('Emissions - ICE', 'Particles').value : 'Not Available';

            if (data.car.tax_band) {
              comparisonTable.querySelector(`[data-cell-content="tax-band"] [data-car=${$spot}] span`).innerText = (data.car.tax_band.band != null) ? data.car.tax_band.band : 'N/A';
              comparisonTable.querySelector(`[data-cell-content="first-year-rate"] [data-car=${$spot}] span`).innerText = (data.car.tax_band.rate != null) ? '£' + data.car.tax_band.rate : 'N/A';
              (parseInt(data.car.tax_band.rate) >= 0) ? comparisonTable.querySelector(`[data-cell-content="first-year-rate"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.tax_band.rate) : '';
              compareColumns('first-year-rate', true);
              comparisonTable.querySelector(`[data-cell-content="year-rate"] [data-car=${$spot}] span`).innerText = (data.car.tax_band.second_rate != null) ? '£' + data.car.tax_band.second_rate : 'N/A';
              (parseInt(data.car.tax_band.second_rate) >= 0) ? comparisonTable.querySelector(`[data-cell-content="year-rate"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.tax_band.second_rate) : '';
              compareColumns('year-rate', true);
            }

            if (data.car.fuel_type === 'Petrol') {
              comparisonTable.querySelector(`[data-cell-content="congestion-charge"] [data-car=${$spot}] span`).innerText = (data.car.tax_band.london != null) ? '£' + data.car.tax_band.london : 'N/A';
              comparisonTable.querySelector(`[data-cell-content="ulez-charge"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions')) ? ((parseInt(getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions').value.slice(-1)) >= 4) ? '£12.50' : '£0') : 'N/A';
            } else if (data.car.fuel_type === 'Diesel') {
              comparisonTable.querySelector(`[data-cell-content="congestion-charge"] [data-car=${$spot}] span`).innerText = (data.car.tax_band.london != null) ? '£' + data.car.tax_band.london : 'N/A';
              comparisonTable.querySelector(`[data-cell-content="ulez-charge"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions')) ? ((parseInt(getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions').value.slice(-1)) >= 6) ? '£12.50' : '£0') : 'N/A';
            } else if (data.car.fuel_type === 'Electric') {
              comparisonTable.querySelector(`[data-cell-content="congestion-charge"] [data-car=${$spot}] span`).innerText = '£0';
              comparisonTable.querySelector(`[data-cell-content="ulez-charge"] [data-car=${$spot}] span`).innerText = '£0';
            } else {
              comparisonTable.querySelector(`[data-cell-content="congestion-charge"] [data-car=${$spot}] span`).innerText = (data.car.tax_band.london != null) ? '£' + data.car.tax_band.london : 'N/A';
              comparisonTable.querySelector(`[data-cell-content="ulez-charge"] [data-car=${$spot}] span`).innerText = '£0';
            }

            if (data.car.tax) {
              comparisonTable.querySelector(`[data-cell-content="bik-1"] [data-car=${$spot}] span`).innerText = (data.car.tax.Year1 != null) ? data.car.tax.Year1 + '%' : 'N/A';
              (parseInt(data.car.tax.Year1) >= 0) ? comparisonTable.querySelector(`[data-cell-content="bik-1"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.tax.Year1) : '';
              compareColumns('bik-1', true);
              comparisonTable.querySelector(`[data-cell-content="bik-2"] [data-car=${$spot}] span`).innerText = (data.car.tax.Year2 != null) ? data.car.tax.Year2 + '%' : 'N/A';
              (parseInt(data.car.tax.Year2) >= 0) ? comparisonTable.querySelector(`[data-cell-content="bik-2"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.tax.Year2) : '';
              compareColumns('bik-2', true);
              comparisonTable.querySelector(`[data-cell-content="bik-3"] [data-car=${$spot}] span`).innerText = (data.car.tax.Year3 != null) ? data.car.tax.Year3 + '%' : 'N/A';
              (parseInt(data.car.tax.Year3) >= 0) ? comparisonTable.querySelector(`[data-cell-content="bik-3"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.tax.Year3) : '';
              compareColumns('bik-3', true);
            }

            if (data.car.from_price) {
              comparisonTable.querySelector(`[data-cell-content="price"] [data-car=${$spot}] span`).innerText = (data.car.from_price.monthly_rental != null) ? '£' + numberWithCommas(parseFloat(data.car.from_price.monthly_rental).toFixed(2)) : 'N/A';
              (parseInt(data.car.from_price.monthly_rental) >= 0) ? comparisonTable.querySelector(`[data-cell-content="price"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.from_price.monthly_rental) : '';
              compareColumns('price', true);
              comparisonTable.querySelector(`[data-cell-content="contract-length"] [data-car=${$spot}] span`).innerText = (data.car.from_price.term != null) ? data.car.from_price.term + ' months' : 'N/A';
              (parseInt(data.car.from_price.term) >= 0) ? comparisonTable.querySelector(`[data-cell-content="contract-length"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.from_price.term) : '';
              comparisonTable.querySelector(`[data-cell-content="initial-profile"] [data-car=${$spot}] span`).innerText = (data.car.from_price.initial_profile != null) ? data.car.from_price.initial_profile + ' months' : 'N/A';
              (parseInt(data.car.from_price.initial_profile) >= 0) ? comparisonTable.querySelector(`[data-cell-content="initial-profile"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.from_price.initial_profile) : '';
              comparisonTable.querySelector(`[data-cell-content="annual-mileage"] [data-car=${$spot}] span`).innerText = (data.car.from_price.mileage != null) ? data.car.from_price.mileage + ' miles' : 'N/A';
              (parseInt(data.car.from_price.mileage) >= 0) ? comparisonTable.querySelector(`[data-cell-content="annual-mileage"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.from_price.mileage) : '';
            }

            comparisonTable.querySelector(`[data-cell-content="vehicle-class"] [data-car=${$spot}] span`).innerText = (data.car.body_type) ? data.car.body_type : 'N/A';
            comparisonTable.querySelector(`[data-cell-content="practicality"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Weight and Capacities', 'No. of Seats') && getCapTechnicalData('Weight and Capacities', 'No. of Seats').value) ? getCapTechnicalData('Weight and Capacities', 'No. of Seats').value + ' seats' : 'N/A';
            // comparisonTable.querySelector(`[data-cell-content="engine-size"] [data-car=${$spot}] .engine-size-cc`).innerText = (getCapTechnicalData('Engine and Drive Train', 'CC') && parseInt(getCapTechnicalData('Engine and Drive Train', 'CC').value) > 1) ? getCapTechnicalData('Engine and Drive Train', 'CC').value + ' cc' : 'N/A';
            // (parseInt(getCapTechnicalData('Engine and Drive Train', 'CC').value) > 1) ? comparisonTable.querySelector(`[data-cell-content="engine-size"] [data-car=${$spot}]`).setAttribute('data-compare', getCapTechnicalData('Engine and Drive Train', 'CC').value) : '';
            // compareColumns('engine-size', false, true);
            // comparisonTable.querySelector(`[data-cell-content="engine-size"] [data-car=${$spot}] .engine-size-litres`).innerText = (getCapTechnicalData('General', 'Badge Engine CC').value) ? ' (' + getCapTechnicalData('General', 'Badge Engine CC').value + ' Litre)' : '';
            comparisonTable.querySelector(`[data-cell-content="transmission"] [data-car=${$spot}] span`).innerText = (data.car.transmission) ? data.car.transmission : 'N/A';
            comparisonTable.querySelector(`[data-cell-content="engine-power"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Performance', 'Engine Power - BHP') && getCapTechnicalData('Performance', 'Engine Power - BHP').value) ? getCapTechnicalData('Performance', 'Engine Power - BHP').value + ' BHP' : 'N/A';
            (parseInt(getCapTechnicalData('Performance', 'Engine Power - BHP').value) > 1) ? comparisonTable.querySelector(`[data-cell-content="engine-power"] [data-car=${$spot}]`).setAttribute('data-compare', getCapTechnicalData('Performance', 'Engine Power - BHP').value) : '';
            compareColumns('engine-power', false, true);
            comparisonTable.querySelector(`[data-cell-content="acceleration"] [data-car=${$spot}] span`).innerText = (data.car.zero_to_60) ? data.car.zero_to_60 + ' Seconds' : 'N/A';
            (parseInt(data.car.zero_to_60) > 1) ? comparisonTable.querySelector(`[data-cell-content="acceleration"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.zero_to_60) : '';
            compareColumns('acceleration', false, true);
            // comparisonTable.querySelector(`[data-cell-content="top-speed"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Performance', 'Top Speed') && getCapTechnicalData('Performance', 'Top Speed').value) ? getCapTechnicalData('Performance', 'Top Speed').value + ' mph' : 'N/A';
            // (getCapTechnicalData('Performance', 'Top Speed')) ? comparisonTable.querySelector(`[data-cell-content="top-speed"] [data-car=${$spot}]`).setAttribute('data-compare', getCapTechnicalData('Performance', 'Top Speed').value) : '';
            // compareColumns('top-speed', false, true);
            if(getCapTechnicalData('General', 'NCAP Overall Rating') && getCapTechnicalData('General', 'NCAP Overall Rating') && getCapTechnicalData('General', 'NCAP Overall Rating').value !== 'Not Available'){
              comparisonTable.querySelector(`[data-cell-content="safety-rating"] [data-car=${$spot}] span`).innerText = '';
              for (let step = 0; step < parseInt(getCapTechnicalData('General', 'NCAP Overall Rating').value); step++) {
                let star = document.createElement("img");
                star.setAttribute('src', '/themes/cbvc/img/icons/general/star-gold.svg');
                comparisonTable.querySelector(`[data-cell-content="safety-rating"] [data-car=${$spot}] span`).appendChild(star);
              }
            } else {
              comparisonTable.querySelector(`[data-cell-content="safety-rating"] [data-car=${$spot}] span`).innerText = 'N/A';
            }
            comparisonTable.querySelector(`[data-cell-content="insurance-group"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('General', 'Insurance Group') && getCapTechnicalData('General', 'Insurance Group').value) ? getCapTechnicalData('General', 'Insurance Group').value : 'N/A';

            (data.car.active == '1') ? comparisonTable.querySelector(`[data-cell-content="cta"] [data-car=${$spot}] a`).setAttribute('href', data.car.full_url) : comparisonTable.querySelector(`[data-cell-content="cta"] [data-car=${$spot}] a`).classList.add('visuallyhidden');

            ($spot === 'third') ? comparisonTable.setAttribute('data-car-form', '0') : comparisonTable.setAttribute('data-car-form', '1');

            // loadModelsCalc('car', 0, true, false)
            loadModelsCalc('car', 0, false, true)

            loadPrice($spot, $derivative)

            comparisonTable.reset();
          }).catch(function(err) {
            console.error('Fetch Error -', err);
          });
        }
      }

      function updateParams() {
        let params = '?' + new URLSearchParams({
          'term': document.querySelector('.quote-terms[name=term]').options[document.querySelector('.quote-terms[name=term]').selectedIndex].value,
          'profile': document.querySelector('.quote-terms[name=profile]').options[document.querySelector('.quote-terms[name=profile]').selectedIndex].value,
          'mileage': document.querySelector('.quote-terms[name=mileage]').options[document.querySelector('.quote-terms[name=mileage]').selectedIndex].value
        });
        comparisonTable.querySelectorAll(`[data-cell-content="img"] a, [data-cell-content="model"] a, [data-cell-content="cta"] a`).forEach((value) => {
          let url;
          (value.getAttribute('href').split('?')[0].includes('/car-leasing/')) ? url = value.getAttribute('href').split('?')[0] + params : url = value.getAttribute('href').split('?')[0];
          value.setAttribute('href', url);
        })
      }


      document.querySelectorAll('.quote-terms').forEach((value) => {
        value.addEventListener('change', (ev) => {
          loadPrice('first', document.querySelector('#car-comparison').dataset.carFirst);
          loadPrice('second', document.querySelector('#car-comparison').dataset.carSecond);
          loadPrice('third', document.querySelector('#car-comparison').dataset.carThird);
          updateParams();
          ev.target.classList.add('visuallyhidden');
          ev.composedPath()[1].querySelector('button').classList.remove('visuallyhidden');
        })
      })

      document.querySelectorAll('#toggle-term, #toggle-profile, #toggle-mileage').forEach((value) => {
        value.addEventListener('click', (ev) => {
          ev.target.classList.add('visuallyhidden');
          ev.composedPath()[1].querySelector('select').classList.remove('visuallyhidden');
        })
      })

      makeField.addEventListener('change', () => {
        (makeField.value > 0) ? loadModelsCalc('car', makeField.value, false, false) : false;
      })

      modelField.addEventListener('change', () => {
        (modelField.value > 0) ? loadDerivativeCalc('car', modelField.value, true, false, true, false) : false;
        derivativeField.dataset.range = makeField.options[makeField.selectedIndex].text + ' ' + modelField.options[modelField.selectedIndex].text;
      });

      setTimeout(() => {
        (comparisonTable.dataset.carFirst > 1) ? loadVehicle('first', comparisonTable.dataset.carFirst) : null;
      }, 200);
      setTimeout(() => {
        (comparisonTable.dataset.carSecond > 1) ? loadVehicle('second', comparisonTable.dataset.carSecond) : null;
      }, 400);
      setTimeout(() => {
        if (comparisonTable.dataset.carThird > 1) {
          loadVehicle('third', comparisonTable.dataset.carThird);
          comparisonTable.setAttribute('data-car-form', '0');
        }
      }, 1000);

      derivativeField.addEventListener('change', (event) => {
        document.querySelectorAll('.show-form').forEach(v => { v.classList.remove('hide') })
        document.querySelectorAll('div[data-car="form"] .form').forEach(v => { v.classList.add('hide') })
        if(event.target.value > 0) {
          document.querySelectorAll('.share-button > a').forEach(value => { value.setAttribute('href', value.getAttribute('href').replace('car[]=&', `car[]=${event.target.value}&`)); })
          if(parseInt(comparisonTable.dataset.carFirst) < 1) {
            loadVehicle('first', event.target.value)
          } else if (parseInt(comparisonTable.dataset.carSecond) < 1) {
            loadVehicle('second', event.target.value)
          } else if (parseInt(comparisonTable.dataset.carThird) < 1) {
            loadVehicle('third', event.target.value)
          }

          let cookie = Cookies.get('compare_list')
          let range_name = derivativeField.dataset.range
          if (cookie) {
            let cookie_obj = JSON.parse(cookie);
            if (Object.keys(cookie_obj).length < 3) {
              if (cookie_obj[event.target.value] === undefined) {
                cookie_obj = {...cookie_obj, [event.target.value] : range_name};
                let cookie_string = JSON.stringify(cookie_obj)
                Cookies.set('compare_list', cookie_string)
              }
            }
          } else {
            let cookie_obj = JSON.parse(`{"${event.target.value}":"${range_name}"}`);
            let cookie_string = JSON.stringify(cookie_obj)
            Cookies.set('compare_list', cookie_string)
          }

        }
      })

      function resetSlot($slot, $id) {
        comparisonTable.setAttribute('data-car-form', '1');
        document.querySelectorAll('div[data-car]').forEach((v) => { v.setAttribute('data-highlight', '') })
        document.querySelectorAll('div[data-car]').forEach((v) => { v.setAttribute('data-compare', '') })
        if ($slot === 'first') {
          comparisonTable.setAttribute('data-car-first', '-1');
        } else if ($slot === 'second') {
          comparisonTable.setAttribute('data-car-second', '-1');
        } else {
          comparisonTable.setAttribute('data-car-third', '-1');
        }
        document.querySelectorAll('.share-button > a').forEach(value => { value.setAttribute('href', (value.getAttribute('href').replace(`car[]=${$id}&`, 'car[]=&'))); });

        let selectedVehicles = [parseInt(comparisonTable.dataset.carFirst), parseInt(comparisonTable.dataset.carSecond), parseInt(comparisonTable.dataset.carThird)];
        [...selectedVehicles].filter(val => val !== -1).forEach((value, index, array) => {
          if (index === 0) {
            (array[0]) ? loadVehicle('first', array[0]) : comparisonTable.setAttribute('data-car-first', '0');
            (array[1]) ? loadVehicle('second', array[1]) : comparisonTable.setAttribute('data-car-second', '0');
            (array[2]) ? loadVehicle('third', array[2]) : comparisonTable.setAttribute('data-car-third', '0');
            let cookie = Cookies.get('compare_list');
            let cookie_obj = JSON.parse(cookie);
            delete cookie_obj[$id];
            (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list');
          }
        })

      }
      document.querySelectorAll('div[data-car] .reset').forEach(value => {
        value.addEventListener('click', evt => {
          document.querySelectorAll('.show-form').forEach(v => { v.classList.remove('hide') })
          document.querySelectorAll('div[data-car="form"] .form').forEach(v => { v.classList.add('hide') })
          comparisonTable.querySelectorAll('a.view-range-button').forEach((v) => { v.classList.remove('visuallyhidden') });
          (evt.target.classList.contains('first')) ? resetSlot('first', comparisonTable.dataset.carFirst) : null;
          (evt.target.classList.contains('second')) ? resetSlot('second', comparisonTable.dataset.carSecond) : null;
          (evt.target.classList.contains('third')) ? resetSlot('third', comparisonTable.dataset.carThird) : null;
        })
      })

      document.querySelectorAll('.show-form').forEach(v => {
        v.addEventListener('click', e => {
          document.querySelectorAll('.show-form').forEach(v => { v.classList.add('hide') })
          document.querySelectorAll('div[data-car="form"] .form').forEach(v => { v.classList.remove('hide') })
        })
      })

    }
    // Compare Vans
    if (document.querySelector('.tools-main>div').classList.contains('van-comparison')) {
      let comparisonTable = document.getElementById('van-comparison')
      let makeField = document.querySelector('.form-first select[name=calculator-make]')
      let modelField = document.querySelector('.form-first select[name=calculator-model]')
      let derivativeField = document.querySelector('.form-first select[name=calculator-derivative]')
      let makeField2 = document.querySelector('.form-second select[name=calculator-make]')
      let modelField2 = document.querySelector('.form-second select[name=calculator-model]')
      let derivativeField2 = document.querySelector('.form-second select[name=calculator-derivative]')
      loadManufacturersCalc('van', true, '.form-first select[name=calculator-make]');
      loadManufacturersCalc('van', true, '.form-second select[name=calculator-make]');

      makeField2.addEventListener('change', e => {
        makeField.selectedIndex = makeField2.selectedIndex;
        makeField.dispatchEvent(new Event('change'));
      })
      modelField2.addEventListener('change', e => {
        modelField.selectedIndex = modelField2.selectedIndex;
        modelField.dispatchEvent(new Event('change'));
      })
      derivativeField2.addEventListener('change', e => {
        derivativeField.selectedIndex = derivativeField2.selectedIndex;
        derivativeField.dispatchEvent(new Event('change'));
      })

      function compareColumns(row, reverse = false, blue = false) {
        let largest = 0
        let smallest = 9999
        comparisonTable.querySelectorAll(`[data-cell-content="${row}"] [data-car][data-compare]`).forEach((value, key, parent) => {
          if (comparisonTable.querySelectorAll(`[data-cell-content="${row}"] [data-car][data-compare]`).length > 1) {
            (largest < parseInt(value.getAttribute('data-compare'))) ? largest = value.getAttribute('data-compare') : '';
            (smallest > parseInt(value.getAttribute('data-compare'))) ? smallest = value.getAttribute('data-compare'): '';
            comparisonTable.querySelectorAll(`[data-cell-content="${row}"] [data-car][data-compare]`).forEach((v) => {v.setAttribute('data-highlight', '')});
            if(largest !== smallest) {
              comparisonTable.querySelectorAll(`[data-cell-content="${row}"] [data-car][data-compare='${largest}']`).forEach((v) => {v.setAttribute('data-highlight', `up-${(blue) ? 'blue' : ((reverse) ? 'red' : 'green')}`)})
              comparisonTable.querySelectorAll(`[data-cell-content="${row}"] [data-car][data-compare='${smallest}']`).forEach((v) => {v.setAttribute('data-highlight', `down-${(blue) ? 'blue' : ((reverse) ? 'green' : 'red')}`)})
            }
          }
        })
      }

      function loadPrice($spot, $derivative) {
        comparisonTable.querySelector(`[data-cell-content="initial-profile"] [data-car=first] span`).innerText = document.querySelector('.quote-terms[name=profile]').options[document.querySelector('.quote-terms[name=profile]').selectedIndex].text;
        comparisonTable.querySelector(`[data-cell-content="initial-profile"] [data-car=second] span`).innerText = document.querySelector('.quote-terms[name=profile]').options[document.querySelector('.quote-terms[name=profile]').selectedIndex].text;
        comparisonTable.querySelector(`[data-cell-content="initial-profile"] [data-car=third] span`).innerText = document.querySelector('.quote-terms[name=profile]').options[document.querySelector('.quote-terms[name=profile]').selectedIndex].text;
        comparisonTable.querySelector(`[data-cell-content="contract-length"] [data-car=first] span`).innerText = document.querySelector('.quote-terms[name=term]').options[document.querySelector('.quote-terms[name=term]').selectedIndex].text;
        comparisonTable.querySelector(`[data-cell-content="contract-length"] [data-car=second] span`).innerText = document.querySelector('.quote-terms[name=term]').options[document.querySelector('.quote-terms[name=term]').selectedIndex].text;
        comparisonTable.querySelector(`[data-cell-content="contract-length"] [data-car=third] span`).innerText = document.querySelector('.quote-terms[name=term]').options[document.querySelector('.quote-terms[name=term]').selectedIndex].text;
        comparisonTable.querySelector(`[data-cell-content="annual-mileage"] [data-car=first] span`).innerText = document.querySelector('.quote-terms[name=mileage]').options[document.querySelector('.quote-terms[name=mileage]').selectedIndex].text;
        comparisonTable.querySelector(`[data-cell-content="annual-mileage"] [data-car=second] span`).innerText = document.querySelector('.quote-terms[name=mileage]').options[document.querySelector('.quote-terms[name=mileage]').selectedIndex].text;
        comparisonTable.querySelector(`[data-cell-content="annual-mileage"] [data-car=third] span`).innerText = document.querySelector('.quote-terms[name=mileage]').options[document.querySelector('.quote-terms[name=mileage]').selectedIndex].text;
        comparisonTable.querySelector(`[data-cell-content="price"] [data-car=${$spot}] span`).innerText = 'Loading...';

        document.querySelector('input[name="van_id"]').value = $derivative;
        let url = '/api/van/price/' + $derivative;
        let formData = new FormData(document.getElementById('van-comparison'));
        fetch(url, {
          method: 'POST',
          body: formData,
        }).then(function (response) {
          if (response.status !== 200) {
            console.warn('Looks like there was a problem. Status Code: ' + response.status);
            return;
          }
          return response.json();
        }).then(function (data) {
          if (data) {
            comparisonTable.querySelector(`[data-cell-content="price"] [data-car=${$spot}] span`).innerText = (data.monthly_rental != null) ? '£' + numberWithCommas(parseFloat(data.monthly_rental).toFixed(2)) : 'N/A';
            (data.monthly_rental != null) ? comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] a.view-range-button`).classList.remove('visually-hidden') : comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] a.view-range-button`).classList.add('visually-hidden');
            (data.monthly_rental != null) ? comparisonTable.querySelector(`[data-cell-content="cta"] [data-car=${$spot}] a.view-range-button`).classList.remove('visually-hidden') : comparisonTable.querySelector(`[data-cell-content="cta"] [data-car=${$spot}] a.view-range-button`).classList.add('visually-hidden');
            (parseInt(data.monthly_rental) >= 0) ? comparisonTable.querySelector(`[data-cell-content="price"] [data-car=${$spot}]`).setAttribute('data-compare', data.monthly_rental) : '';
            compareColumns('price', true);
            // comparisonTable.querySelector(`[data-cell-content="contract-length"] [data-car=${$spot}] span`).innerText = (data.term != null) ? data.term + ' months' : 'N/A';
            // (parseInt(data.term) >= 0) ? comparisonTable.querySelector(`[data-cell-content="contract-length"] [data-car=${$spot}]`).setAttribute('data-compare', data.term) : '';
            // comparisonTable.querySelector(`[data-cell-content="initial-profile"] [data-car=${$spot}] span`).innerText = (data.initial_profile != null) ? data.initial_profile + ' months' : 'N/A';
            // (parseInt(data.initial_profile) >= 0) ? comparisonTable.querySelector(`[data-cell-content="initial-profile"] [data-car=${$spot}]`).setAttribute('data-compare', data.initial_profile) : '';
            // comparisonTable.querySelector(`[data-cell-content="annual-mileage"] [data-car=${$spot}] span`).innerText = (data.mileage != null) ? data.mileage + ' miles' : 'N/A';
            // (parseInt(data.mileage) >= 0) ? comparisonTable.querySelector(`[data-cell-content="annual-mileage"] [data-car=${$spot}]`).setAttribute('data-compare', data.mileage) : '';
          }
        }).catch(function (err) {
          console.error('Fetch Error -', err);
          document.getElementsByClassName('price')[0].classList.remove('hidden');
          document.getElementsByClassName('price-fetching')[0].classList.add('hidden');
        });
      }

      function setLinks($spot, $active, $url, $fuel) {
        let params = '?' + new URLSearchParams({
          'term': document.querySelector('.quote-terms[name=term]').options[document.querySelector('.quote-terms[name=term]').selectedIndex].value,
          'profile': document.querySelector('.quote-terms[name=profile]').options[document.querySelector('.quote-terms[name=profile]').selectedIndex].value,
          'mileage': document.querySelector('.quote-terms[name=mileage]').options[document.querySelector('.quote-terms[name=mileage]').selectedIndex].value
        });
        ($active == '1') ? comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] a.view-range-button`).setAttribute('href', $url + params) : comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] a.view-range-button`).classList.add('visually-hidden');
        ($active == '1') ? comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] a.view-range-button`).setAttribute('href', $url + params) : comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] a.view-range-button`).classList.add('visually-hidden');
        ($active == '1') ? comparisonTable.querySelector(`[data-cell-content="cta"] [data-car=${$spot}] a.view-range-button`).setAttribute('href', $url + params) : comparisonTable.querySelector(`[data-cell-content="cta"] [data-car=${$spot}] a.view-range-button`).classList.add('visually-hidden');
      }

      function loadVehicle($spot, $derivative) {
        if ($derivative !== 0) {
          let url = '/api/van/' + $derivative;
          let params = '?' + new URLSearchParams({'type': (document.querySelector('#van-comparison input[name=type]')).value});
          fetch(url + params).then(function(response) {
            if (response.status !== 200) {
              console.warn('Looks like there was a problem. Status Code: ' + response.status);
              return;
            }
            return response.json();
          }).then(function(data) {
            let getCapTechnicalData;
            if(data.car.technical) {
              getCapTechnicalData = ($category, $term) => (data.car.technical[$category] !== undefined) ? (data.car.technical[$category].find(item => item.name.includes($term))) : false;
            } else {
              getCapTechnicalData = ($category, $term) => 'N/A';
            }
            comparisonTable.setAttribute(`data-car-${$spot}`, $derivative);

            comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] .make`).innerText = data.car.range_name;
            comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] .derivative`).innerText = data.car.name;

            (data.car.active == '1') ? comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] a.view-range-button`).setAttribute('href', data.car.full_url) : comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] a.view-range-button`).classList.add('visually-hidden');
            (data.car.active == '1') ? comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] a.view-range-button`).setAttribute('href', data.car.full_url) : comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] a.view-range-button`).classList.add('visually-hidden');

            comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] img`).setAttribute('onerror', `this.src="${data.car.main_img}"`);
            data.car.main_img.includes('std/') ? comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] img`).setAttribute('src', data.car.main_img.replace('std/', 'big/')) : comparisonTable.querySelector(`[data-cell-content="img"] [data-car=${$spot}] img`).setAttribute('src', data.car.main_img);

            setLinks($spot, data.car.active, data.car.full_url, data.car.fuel_type);

            comparisonTable.querySelector(`[data-cell-content="fuel-type"] [data-car=${$spot}] span`).innerText = (data.car.fuel_type) ? data.car.fuel_type : 'N/A';
            // comparisonTable.querySelector(`[data-cell-content="p11d"] [data-car=${$spot}] span`).innerText = (data.car.base_price) ? '£' + numberWithCommas((parseFloat(data.car.base_price)).toFixed(0)) : 'N/A';
            comparisonTable.querySelector(`[data-cell-content="electric-range"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Electric Vehicle Data', 'Pure Electric Range (miles) - Comb - Min') && getCapTechnicalData('Electric Vehicle Data', 'Pure Electric Range (miles) - Comb - Min').value) ? getCapTechnicalData('Electric Vehicle Data', 'Pure Electric Range (miles) - Comb - Min').value + ' miles' : ((data.car.electric_range) ? data.car.electric_range + ' miles' : 'N/A');
            (getCapTechnicalData('Electric Vehicle Data', 'Pure Electric Range (miles) - Comb - Min') && getCapTechnicalData('Electric Vehicle Data', 'Pure Electric Range (miles) - Comb - Min').value) ? comparisonTable.querySelector(`[data-cell-content="electric-range"] [data-car=${$spot}]`).setAttribute('data-compare', getCapTechnicalData('Electric Vehicle Data', 'Pure Electric Range (miles) - Comb - Min').value) : comparisonTable.querySelector(`[data-cell-content="electric-range"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.electric_range);
            compareColumns('electric-range');
            comparisonTable.querySelector(`[data-cell-content="real-electric-range"] [data-car=${$spot}] span`).innerText = (data.car.electric_range_real_world) ? data.car.electric_range_real_world + ' miles' : 'N/A';
            (parseInt(data.car.electric_range_real_world) > 0) ? comparisonTable.querySelector(`[data-cell-content="real-electric-range"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.electric_range_real_world) : '';
            compareColumns('real-electric-range');

            comparisonTable.querySelector(`[data-cell-content="official-mpg"] [data-car=${$spot}] span`).innerText = (data.car.mpg_combined && parseInt(data.car.mpg_combined) > 0) ? data.car.mpg_combined + ' mpg' : 'N/A';
            (parseInt(data.car.mpg_combined) > 0) ? comparisonTable.querySelector(`[data-cell-content="official-mpg"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.mpg_combined) : '';
            compareColumns('official-mpg');
            comparisonTable.querySelector(`[data-cell-content="real-mpg"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Fuel Consumption - ICE', 'WLTP - MPG - Comb - Max') && getCapTechnicalData('Fuel Consumption - ICE', 'WLTP - MPG - Comb - Max').value) ? getCapTechnicalData('Fuel Consumption - ICE', 'WLTP - MPG - Comb - Max').value + ' mpg' : 'N/A';
            (getCapTechnicalData('Fuel Consumption - ICE', 'WLTP - MPG - Comb - Max')) ? comparisonTable.querySelector(`[data-cell-content="real-mpg"] [data-car=${$spot}]`).setAttribute('data-compare', getCapTechnicalData('Fuel Consumption - ICE', 'WLTP - MPG - Comb - Max').value) : '';
            compareColumns('real-mpg');

            let indicative_fuel_cost = indicativeCost(data.car.fuel_type, (data.car.mpg_combined != null) ? data.car.mpg_combined : ((data.car.mpg_urban != null) ? data.car.mpg_urban : data.car.mpg_extra), (data.car.electric_range != null) ? data.car.electric_range : null, data.car.battery_capacity);
            comparisonTable.querySelector(`[data-cell-content="indicative-cost"] [data-car=${$spot}] span`).innerText = (parseInt(indicative_fuel_cost) >= 0) ? indicative_fuel_cost + ' p/mile' : 'N/A';
            (parseInt(indicative_fuel_cost) >= 0) ? comparisonTable.querySelector(`[data-cell-content="indicative-cost"] [data-car=${$spot}]`).setAttribute('data-compare', indicative_fuel_cost) : '';
            compareColumns('indicative-cost', true);

            // comparisonTable.querySelector(`[data-cell-content="green-car-rating"] [data-car=${$spot}] span`).innerText = 'N/A';
            // comparisonTable.querySelector(`[data-cell-content="climate-air"] [data-car=${$spot}] span`).innerText = 'N/A';getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions')
            comparisonTable.querySelector(`[data-cell-content="co2-emissions"] [data-car=${$spot}] span`).innerText = (data.car.co2) ? parseInt(data.car.co2).toFixed(0) + ' g/km' : 'N/A';
            comparisonTable.querySelector(`[data-cell-content="euro-standard"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions') && getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions').value) ? getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions').value : 'N/A';
            // comparisonTable.querySelector(`[data-cell-content="nox"] [data-car=${$spot}] span .nox`).innerText = (getCapTechnicalData('Emissions - ICE', 'NOx')) ? getCapTechnicalData('Emissions - ICE', 'NOx').value : 'Not Available';
            // comparisonTable.querySelector(`[data-cell-content="nox"] [data-car=${$spot}] span .particles`).innerText = (getCapTechnicalData('Emissions - ICE', 'Particles')) ? getCapTechnicalData('Emissions - ICE', 'Particles').value : 'Not Available';

            // if (data.car.tax_band) {
            //   comparisonTable.querySelector(`[data-cell-content="tax-band"] [data-car=${$spot}] span`).innerText = (data.car.tax_band.band != null) ? data.car.tax_band.band : 'N/A';
            //   comparisonTable.querySelector(`[data-cell-content="first-year-rate"] [data-car=${$spot}] span`).innerText = (data.car.tax_band.rate != null) ? '£' + data.car.tax_band.rate : 'N/A';
            //   (parseInt(data.car.tax_band.rate) >= 0) ? comparisonTable.querySelector(`[data-cell-content="first-year-rate"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.tax_band.rate) : '';
            //   compareColumns('first-year-rate', true);
            //   comparisonTable.querySelector(`[data-cell-content="year-rate"] [data-car=${$spot}] span`).innerText = (data.car.tax_band.second_rate != null) ? '£' + data.car.tax_band.second_rate : 'N/A';
            //   (parseInt(data.car.tax_band.second_rate) >= 0) ? comparisonTable.querySelector(`[data-cell-content="year-rate"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.tax_band.second_rate) : '';
            //   compareColumns('year-rate', true);
            // }

            comparisonTable.querySelector(`[data-cell-content="van-height"] [data-car=${$spot}] span`).innerText = (data.car.height) ? parseInt(data.car.height).toFixed(0) + ' mm' : 'N/A';
            (parseInt(data.car.height) > 0) ? comparisonTable.querySelector(`[data-cell-content="van-height"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.height) : '';
            compareColumns('van-height');
            comparisonTable.querySelector(`[data-cell-content="van-length"] [data-car=${$spot}] span`).innerText = (data.car.length) ? parseInt(data.car.length).toFixed(0) + ' mm' : 'N/A';
            (parseInt(data.car.length) > 0) ? comparisonTable.querySelector(`[data-cell-content="van-length"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.length) : '';
            compareColumns('van-length');
            comparisonTable.querySelector(`[data-cell-content="van-wheel_base"] [data-car=${$spot}] span`).innerText = (data.car.wheel_base) ? parseInt(data.car.wheel_base).toFixed(0) + ' mm' : 'N/A';
            (parseInt(data.car.wheel_base) > 0) ? comparisonTable.querySelector(`[data-cell-content="van-wheel_base"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.wheel_base) : '';
            compareColumns('van-wheel_base');
            comparisonTable.querySelector(`[data-cell-content="van-load_width"] [data-car=${$spot}] span`).innerText = (data.car.load_width) ? parseInt(data.car.load_width).toFixed(0) + ' mm' : 'N/A';
            (parseInt(data.car.load_width) > 0) ? comparisonTable.querySelector(`[data-cell-content="van-load_width"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.load_width) : '';
            compareColumns('van-load_width');
            comparisonTable.querySelector(`[data-cell-content="van-load_height"] [data-car=${$spot}] span`).innerText = (data.car.load_height) ? parseInt(data.car.load_height).toFixed(0) + ' mm' : 'N/A';
            (parseInt(data.car.load_height) > 0) ? comparisonTable.querySelector(`[data-cell-content="van-load_height"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.load_height) : '';
            compareColumns('van-load_height');
            comparisonTable.querySelector(`[data-cell-content="van-load_length"] [data-car=${$spot}] span`).innerText = (data.car.load_length) ? parseInt(data.car.load_length).toFixed(0) + ' mm' : 'N/A';
            (parseInt(data.car.load_length) > 0) ? comparisonTable.querySelector(`[data-cell-content="van-load_length"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.load_length) : '';
            compareColumns('van-load_length');
            comparisonTable.querySelector(`[data-cell-content="van-payload"] [data-car=${$spot}] span`).innerText = (data.car.payload) ? parseInt(data.car.payload).toFixed(0) + ' kg' : 'N/A';
            (parseInt(data.car.payload) > 0) ? comparisonTable.querySelector(`[data-cell-content="van-payload"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.payload) : '';
            compareColumns('van-payload');
            comparisonTable.querySelector(`[data-cell-content="van-load_space"] [data-car=${$spot}] span`).innerText = (data.car.load_space) ? parseInt(data.car.load_space).toFixed(0) + ' m3' : 'N/A';
            (parseInt(data.car.load_space) > 0) ? comparisonTable.querySelector(`[data-cell-content="van-load_space"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.load_space) : '';
            compareColumns('van-load_space');
            // if (data.car.fuel_type === 'Petrol') {
            //   comparisonTable.querySelector(`[data-cell-content="congestion-charge"] [data-car=${$spot}] span`).innerText = (data.car.tax_band.london != null) ? '£' + data.car.tax_band.london : 'N/A';
            //   comparisonTable.querySelector(`[data-cell-content="ulez-charge"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions')) ? ((parseInt(getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions').value.slice(-1)) >= 4) ? '£12.50' : '£0') : 'N/A';
            // } else if (data.car.fuel_type === 'Diesel') {
            //   comparisonTable.querySelector(`[data-cell-content="congestion-charge"] [data-car=${$spot}] span`).innerText = (data.car.tax_band.london != null) ? '£' + data.car.tax_band.london : 'N/A';
            //   comparisonTable.querySelector(`[data-cell-content="ulez-charge"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions')) ? ((parseInt(getCapTechnicalData('Emissions - ICE', 'Standard Euro Emissions').value.slice(-1)) >= 6) ? '£12.50' : '£0') : 'N/A';
            // } else if (data.car.fuel_type === 'Electric') {
            //   comparisonTable.querySelector(`[data-cell-content="congestion-charge"] [data-car=${$spot}] span`).innerText = '£0';
            //   comparisonTable.querySelector(`[data-cell-content="ulez-charge"] [data-car=${$spot}] span`).innerText = '£0';
            // } else {
            //   comparisonTable.querySelector(`[data-cell-content="congestion-charge"] [data-car=${$spot}] span`).innerText = (data.car.tax_band.london != null) ? '£' + data.car.tax_band.london : 'N/A';
            //   comparisonTable.querySelector(`[data-cell-content="ulez-charge"] [data-car=${$spot}] span`).innerText = '£0';
            // }

            // if (data.car.tax) {
            //   comparisonTable.querySelector(`[data-cell-content="bik-1"] [data-car=${$spot}] span`).innerText = (data.car.tax.Year1 != null) ? data.car.tax.Year1 + '%' : 'N/A';
            //   (parseInt(data.car.tax.Year1) >= 0) ? comparisonTable.querySelector(`[data-cell-content="bik-1"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.tax.Year1) : '';
            //   compareColumns('bik-1', true);
            //   comparisonTable.querySelector(`[data-cell-content="bik-2"] [data-car=${$spot}] span`).innerText = (data.car.tax.Year2 != null) ? data.car.tax.Year2 + '%' : 'N/A';
            //   (parseInt(data.car.tax.Year2) >= 0) ? comparisonTable.querySelector(`[data-cell-content="bik-2"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.tax.Year2) : '';
            //   compareColumns('bik-2', true);
            //   comparisonTable.querySelector(`[data-cell-content="bik-3"] [data-car=${$spot}] span`).innerText = (data.car.tax.Year3 != null) ? data.car.tax.Year3 + '%' : 'N/A';
            //   (parseInt(data.car.tax.Year3) >= 0) ? comparisonTable.querySelector(`[data-cell-content="bik-3"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.tax.Year3) : '';
            //   compareColumns('bik-3', true);
            // }

            if (data.car.from_price) {
              comparisonTable.querySelector(`[data-cell-content="price"] [data-car=${$spot}] span`).innerText = (data.car.from_price.monthly_rental != null) ? '£' + numberWithCommas(parseFloat(data.car.from_price.monthly_rental).toFixed(2)) : 'N/A';
              (parseInt(data.car.from_price.monthly_rental) >= 0) ? comparisonTable.querySelector(`[data-cell-content="price"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.from_price.monthly_rental) : '';
              compareColumns('price', true);
              comparisonTable.querySelector(`[data-cell-content="contract-length"] [data-car=${$spot}] span`).innerText = (data.car.from_price.term != null) ? data.car.from_price.term + ' months' : 'N/A';
              (parseInt(data.car.from_price.term) >= 0) ? comparisonTable.querySelector(`[data-cell-content="contract-length"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.from_price.term) : '';
              comparisonTable.querySelector(`[data-cell-content="initial-profile"] [data-car=${$spot}] span`).innerText = (data.car.from_price.initial_profile != null) ? data.car.from_price.initial_profile + ' months' : 'N/A';
              (parseInt(data.car.from_price.initial_profile) >= 0) ? comparisonTable.querySelector(`[data-cell-content="initial-profile"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.from_price.initial_profile) : '';
              comparisonTable.querySelector(`[data-cell-content="annual-mileage"] [data-car=${$spot}] span`).innerText = (data.car.from_price.mileage != null) ? data.car.from_price.mileage + ' miles' : 'N/A';
              (parseInt(data.car.from_price.mileage) >= 0) ? comparisonTable.querySelector(`[data-cell-content="annual-mileage"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.from_price.mileage) : '';
            }

            comparisonTable.querySelector(`[data-cell-content="vehicle-class"] [data-car=${$spot}] span`).innerText = (data.car.body_type) ? data.car.body_type : 'N/A';
            comparisonTable.querySelector(`[data-cell-content="practicality"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Weight and Capacities', 'No. of Seats') && getCapTechnicalData('Weight and Capacities', 'No. of Seats').value) ? getCapTechnicalData('Weight and Capacities', 'No. of Seats').value + ' seats' : 'N/A';
            // comparisonTable.querySelector(`[data-cell-content="engine-size"] [data-car=${$spot}] .engine-size-cc`).innerText = (getCapTechnicalData('Engine and Drive Train', 'CC') && parseInt(getCapTechnicalData('Engine and Drive Train', 'CC').value) > 1) ? getCapTechnicalData('Engine and Drive Train', 'CC').value + ' cc' : 'N/A';
            // (parseInt(getCapTechnicalData('Engine and Drive Train', 'CC').value) > 1) ? comparisonTable.querySelector(`[data-cell-content="engine-size"] [data-car=${$spot}]`).setAttribute('data-compare', getCapTechnicalData('Engine and Drive Train', 'CC').value) : '';
            // compareColumns('engine-size', false, true);
            // comparisonTable.querySelector(`[data-cell-content="engine-size"] [data-car=${$spot}] .engine-size-litres`).innerText = (getCapTechnicalData('General', 'Badge Engine CC').value) ? ' (' + getCapTechnicalData('General', 'Badge Engine CC').value + ' Litre)' : '';
            comparisonTable.querySelector(`[data-cell-content="transmission"] [data-car=${$spot}] span`).innerText = (data.car.transmission) ? data.car.transmission : 'N/A';
            comparisonTable.querySelector(`[data-cell-content="engine-power"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Performance', 'Engine Power - BHP') && getCapTechnicalData('Performance', 'Engine Power - BHP').value) ? getCapTechnicalData('Performance', 'Engine Power - BHP').value + ' BHP' : 'N/A';
            (getCapTechnicalData('Performance', 'Engine Power - BHP')) ? comparisonTable.querySelector(`[data-cell-content="engine-power"] [data-car=${$spot}]`).setAttribute('data-compare', getCapTechnicalData('Performance', 'Engine Power - BHP').value) : '';
            compareColumns('engine-power', false, true);
            comparisonTable.querySelector(`[data-cell-content="acceleration"] [data-car=${$spot}] span`).innerText = (data.car.zero_to_60) ? data.car.zero_to_60 + ' Seconds' : 'N/A';
            (parseInt(data.car.zero_to_60) > 1) ? comparisonTable.querySelector(`[data-cell-content="acceleration"] [data-car=${$spot}]`).setAttribute('data-compare', data.car.zero_to_60) : '';
            compareColumns('acceleration', false, true);
            // comparisonTable.querySelector(`[data-cell-content="top-speed"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('Performance', 'Top Speed') && getCapTechnicalData('Performance', 'Top Speed').value) ? getCapTechnicalData('Performance', 'Top Speed').value + ' mph' : 'N/A';
            // (getCapTechnicalData('Performance', 'Top Speed')) ? comparisonTable.querySelector(`[data-cell-content="top-speed"] [data-car=${$spot}]`).setAttribute('data-compare', getCapTechnicalData('Performance', 'Top Speed').value) : '';
            // compareColumns('top-speed', false, true);
            if(getCapTechnicalData('General', 'NCAP Overall Rating') && getCapTechnicalData('General', 'NCAP Overall Rating') && getCapTechnicalData('General', 'NCAP Overall Rating').value !== 'Not Available'){
              comparisonTable.querySelector(`[data-cell-content="safety-rating"] [data-car=${$spot}] span`).innerText = '';
              for (let step = 0; step < parseInt(getCapTechnicalData('General', 'NCAP Overall Rating').value); step++) {
                let star = document.createElement("img");
                star.setAttribute('src', '/themes/cbvc/img/icons/general/star-gold.svg');
                comparisonTable.querySelector(`[data-cell-content="safety-rating"] [data-car=${$spot}] span`).appendChild(star);
              }
            } else {
              comparisonTable.querySelector(`[data-cell-content="safety-rating"] [data-car=${$spot}] span`).innerText = 'N/A';
            }
            comparisonTable.querySelector(`[data-cell-content="insurance-group"] [data-car=${$spot}] span`).innerText = (getCapTechnicalData('General', 'Insurance Group') && getCapTechnicalData('General', 'Insurance Group').value) ? getCapTechnicalData('General', 'Insurance Group').value : 'N/A';

            (data.car.active == '1') ? comparisonTable.querySelector(`[data-cell-content="cta"] [data-car=${$spot}] a`).setAttribute('href', data.car.full_url) : comparisonTable.querySelector(`[data-cell-content="cta"] [data-car=${$spot}] a`).classList.add('visuallyhidden');

            ($spot === 'third') ? comparisonTable.setAttribute('data-car-form', '0') : comparisonTable.setAttribute('data-car-form', '1');

            // loadModelsCalc('car', 0, true, false)
            loadModelsCalc('van', 0, false, true)

            loadPrice($spot, $derivative)

            comparisonTable.reset();
          }).catch(function(err) {
            console.error('Fetch Error -', err);
          });
        }
      }

      function updateParams() {
        let params = '?' + new URLSearchParams({
          'term': document.querySelector('.quote-terms[name=term]').options[document.querySelector('.quote-terms[name=term]').selectedIndex].value,
          'profile': document.querySelector('.quote-terms[name=profile]').options[document.querySelector('.quote-terms[name=profile]').selectedIndex].value,
          'mileage': document.querySelector('.quote-terms[name=mileage]').options[document.querySelector('.quote-terms[name=mileage]').selectedIndex].value
        });
        comparisonTable.querySelectorAll(`[data-cell-content="img"] a, [data-cell-content="model"] a, [data-cell-content="cta"] a`).forEach((value) => {
          let url;
          (value.getAttribute('href').split('?')[0].includes('/van-leasing/')) ? url = value.getAttribute('href').split('?')[0] + params : url = value.getAttribute('href').split('?')[0];
          value.setAttribute('href', url);
        })
      }


      document.querySelectorAll('.quote-terms').forEach((value) => {
        value.addEventListener('change', (ev) => {
          loadPrice('first', document.querySelector('#van-comparison').dataset.carFirst);
          loadPrice('second', document.querySelector('#van-comparison').dataset.carSecond);
          loadPrice('third', document.querySelector('#van-comparison').dataset.carThird);
          updateParams();
          ev.target.classList.add('visuallyhidden');
          ev.composedPath()[1].querySelector('button').classList.remove('visuallyhidden');
        })
      })

      document.querySelectorAll('#toggle-term, #toggle-profile, #toggle-mileage').forEach((value) => {
        value.addEventListener('click', (ev) => {
          ev.target.classList.add('visuallyhidden');
          ev.composedPath()[1].querySelector('select').classList.remove('visuallyhidden');
        })
      })

      makeField.addEventListener('change', () => {
        (makeField.value > 0) ? loadModelsCalc('van', makeField.value, false, false) : false;
      })

      modelField.addEventListener('change', () => {
        (modelField.value > 0) ? loadDerivativeCalc('van', modelField.value, true, false, true, false) : false;
        derivativeField.dataset.range = makeField.options[makeField.selectedIndex].text + ' ' + modelField.options[modelField.selectedIndex].text;
      });

      setTimeout(() => {
        (comparisonTable.dataset.carFirst > 1) ? loadVehicle('first', comparisonTable.dataset.carFirst) : null;
      }, 200);
      setTimeout(() => {
        (comparisonTable.dataset.carSecond > 1) ? loadVehicle('second', comparisonTable.dataset.carSecond) : null;
      }, 400);
      setTimeout(() => {
        if (comparisonTable.dataset.carThird > 1) {
          loadVehicle('third', comparisonTable.dataset.carThird);
          comparisonTable.setAttribute('data-car-form', '0');
        }
      }, 1000);

      derivativeField.addEventListener('change', (event) => {
        document.querySelectorAll('.show-form').forEach(v => { v.classList.remove('hide') })
        document.querySelectorAll('div[data-car="form"] .form').forEach(v => { v.classList.add('hide') })
        if(event.target.value > 0) {
          document.querySelectorAll('.share-button > a').forEach(value => { value.setAttribute('href', value.getAttribute('href').replace('car[]=&', `car[]=${event.target.value}&`)); })
          if(parseInt(comparisonTable.dataset.carFirst) < 1) {
            loadVehicle('first', event.target.value)
          } else if (parseInt(comparisonTable.dataset.carSecond) < 1) {
            loadVehicle('second', event.target.value)
          } else if (parseInt(comparisonTable.dataset.carThird) < 1) {
            loadVehicle('third', event.target.value)
          }

          let cookie = Cookies.get('compare_list_vans')
          let range_name = derivativeField.dataset.range
          if (cookie) {
            let cookie_obj = JSON.parse(cookie);
            if (Object.keys(cookie_obj).length < 3) {
              if (cookie_obj[event.target.value] === undefined) {
                cookie_obj = {...cookie_obj, [event.target.value] : range_name};
                let cookie_string = JSON.stringify(cookie_obj)
                Cookies.set('compare_list_vans', cookie_string)
              }
            }
          } else {
            let cookie_obj = JSON.parse(`{"${event.target.value}":"${range_name}"}`);
            let cookie_string = JSON.stringify(cookie_obj)
            Cookies.set('compare_list_vans', cookie_string)
          }

        }
      })

      function resetSlot($slot, $id) {
        comparisonTable.setAttribute('data-car-form', '1');
        document.querySelectorAll('div[data-car]').forEach((v) => { v.setAttribute('data-highlight', '') })
        document.querySelectorAll('div[data-car]').forEach((v) => { v.setAttribute('data-compare', '') })
        if ($slot === 'first') {
          comparisonTable.setAttribute('data-car-first', '-1');
        } else if ($slot === 'second') {
          comparisonTable.setAttribute('data-car-second', '-1');
        } else {
          comparisonTable.setAttribute('data-car-third', '-1');
        }
        document.querySelectorAll('.share-button > a').forEach(value => { value.setAttribute('href', (value.getAttribute('href').replace(`car[]=${$id}&`, 'car[]=&'))); });

        let selectedVehicles = [parseInt(comparisonTable.dataset.carFirst), parseInt(comparisonTable.dataset.carSecond), parseInt(comparisonTable.dataset.carThird)];
        [...selectedVehicles].filter(val => val !== -1).forEach((value, index, array) => {
          if (index === 0) {
            (array[0]) ? loadVehicle('first', array[0]) : comparisonTable.setAttribute('data-car-first', '0');
            (array[1]) ? loadVehicle('second', array[1]) : comparisonTable.setAttribute('data-car-second', '0');
            (array[2]) ? loadVehicle('third', array[2]) : comparisonTable.setAttribute('data-car-third', '0');
            let cookie = Cookies.get('compare_list_vans');
            let cookie_obj = JSON.parse(cookie);
            delete cookie_obj[$id];
            (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list_vans', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list_vans');
          }
        })

      }
      document.querySelectorAll('div[data-car] .reset').forEach(value => {
        value.addEventListener('click', evt => {
          document.querySelectorAll('.show-form').forEach(v => { v.classList.remove('hide') })
          document.querySelectorAll('div[data-car="form"] .form').forEach(v => { v.classList.add('hide') })
          comparisonTable.querySelectorAll('a.view-range-button').forEach((v) => { v.classList.remove('visuallyhidden') });
          (evt.target.classList.contains('first')) ? resetSlot('first', comparisonTable.dataset.carFirst) : null;
          (evt.target.classList.contains('second')) ? resetSlot('second', comparisonTable.dataset.carSecond) : null;
          (evt.target.classList.contains('third')) ? resetSlot('third', comparisonTable.dataset.carThird) : null;
        })
      })

      document.querySelectorAll('.show-form').forEach(v => {
        v.addEventListener('click', e => {
          document.querySelectorAll('.show-form').forEach(v => { v.classList.add('hide') })
          document.querySelectorAll('div[data-car="form"] .form').forEach(v => { v.classList.remove('hide') })
        })
      })

    }
  }

  // Add To Compare - Car
  document.querySelectorAll('button[data-compare][data-type="car"]').forEach((value) => {
    value.addEventListener('click', (e) => {
      e.preventDefault();
      let cookie = Cookies.get('compare_list')
      if (cookie) {
        let cookie_obj = JSON.parse(cookie);
        if (cookie_obj[e.target.dataset.compare] === undefined) {
          if (Object.keys(cookie_obj).length < 3) {
            cookie_obj = {...cookie_obj, [e.target.dataset.compare] : e.target.dataset.name};
            let cookie_string = JSON.stringify(cookie_obj)
            Cookies.set('compare_list', cookie_string)
            e.target.innerHTML = `<svg width="16" height="16"><use xlink:href="/themes/cbvc/img/icons/compare-remove.svg#compare"></use></svg> Remove`;
            e.target.dataset.compareAdded = 'true';
            alertify.confirm('Car Comparison')
                .setting({
                  'title': 'Car Comparison',
                  'message': `
                  <span class="semi-bold">${e.target.dataset.name}</span> added to comparison
                  ${(cookie_obj[Object.keys(cookie_obj)[0]] !== undefined) ? `
                    <br><br> <span class="semi-bold">You are comparing:</span>
                    <ul>
                      <li><span>${cookie_obj[Object.keys(cookie_obj)[0]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[0]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2216\\x22 height=\\x2216\\x22><use xlink:href=\\x22/themes/cbvc/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>
                      ${(cookie_obj[Object.keys(cookie_obj)[1]] !== undefined) ? `<li><span>${cookie_obj[Object.keys(cookie_obj)[1]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[1]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2216\\x22 height=\\x2216\\x22><use xlink:href=\\x22/themes/cbvc/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>` : ''}
                      ${(cookie_obj[Object.keys(cookie_obj)[2]] !== undefined) ? `<li><span>${cookie_obj[Object.keys(cookie_obj)[2]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[2]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2216\\x22 height=\\x2216\\x22><use xlink:href=\\x22/themes/cbvc/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>` : ''}
                    </ul>
                  ` : ''}
                `,
                  'labels': { ok: 'Go To Compare', cancel: 'Close' },
                  'onok': function(){ window.location.href = "/tools/car-comparison" }
                });
          } else {
            alertify.confirm('Car Comparison')
                .setting({
                  'title': 'Car Comparison',
                  'message': `
                  <span class="semi-bold">Car comparison full.</span>
                  <br><br>
                  <span>If you wish to continue remove one of the items below and add ${e.target.dataset.name} again.</span>
                  <br><br> <span class="semi-bold">You are comparing:</span>
                  <ul>
                    <li><span>${cookie_obj[Object.keys(cookie_obj)[0]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[0]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2216\\x22 height=\\x2216\\x22><use xlink:href=\\x22/themes/cbvc/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>
                    <li><span>${cookie_obj[Object.keys(cookie_obj)[1]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[1]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2216\\x22 height=\\x2216\\x22><use xlink:href=\\x22/themes/cbvc/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>
                    <li><span>${cookie_obj[Object.keys(cookie_obj)[2]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[2]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2216\\x22 height=\\x2216\\x22><use xlink:href=\\x22/themes/cbvc/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>
                  </ul>
                `,
                  'labels': { ok: 'Go To Compare', cancel: 'Close' },
                  'onok': function(){ window.location.href = "/tools/car-comparison" }
                });
          }
        } else {
          delete cookie_obj[e.target.dataset.compare];
          (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list');
          e.target.innerHTML = `<svg width="16" height="16"><use xlink:href="/themes/cbvc/img/icons/compare.svg#compare"></use></svg> Compare`;
          e.target.dataset.compareAdded = 'false';
          alertify.confirm('Car Comparison')
              .setting({
                'title': 'Car Comparison',
                'message': `<span class="semi-bold">${e.target.dataset.name}</span> removed from comparison`,
                'labels': { ok: 'Go To Compare', cancel: 'Close' },
                'onok': function(){ window.location.href = "/tools/car-comparison" }
              });
        }
      } else {
        let cookie_obj = JSON.parse(`{"${e.target.dataset.compare}":"${e.target.dataset.name}"}`);
        let cookie_string = JSON.stringify(cookie_obj)
        Cookies.set('compare_list', cookie_string)
        e.target.innerHTML = `<svg width="16" height="16"><use xlink:href="/themes/cbvc/img/icons/compare-remove.svg#compare"></use></svg> Remove`;
        e.target.dataset.compareAdded = 'true';

        alertify.confirm('Car Comparison')
            .setting({
              'title': 'Car Comparison',
              'message': `<span class="semi-bold">${e.target.dataset.name}</span> added to comparison`,
              'labels': { ok: 'Go To Compare', cancel: 'Close' },
              'onok': function(){ window.location.href = "/tools/car-comparison" }
            });
      }
    })
  })
  // Add To Compare - Van
  document.querySelectorAll('button[data-compare][data-type="van"]').forEach((value) => {
    value.addEventListener('click', (e) => {
      e.preventDefault();
      let cookie = Cookies.get('compare_list_vans')
      if (cookie) {
        let cookie_obj = JSON.parse(cookie);
        if (cookie_obj[e.target.dataset.compare] === undefined) {
          if (Object.keys(cookie_obj).length < 3) {
            cookie_obj = {...cookie_obj, [e.target.dataset.compare] : e.target.dataset.name};
            let cookie_string = JSON.stringify(cookie_obj)
            Cookies.set('compare_list_vans', cookie_string)
            e.target.innerHTML = `<svg width="16" height="16"><use xlink:href="/themes/cbvc/img/icons/compare-remove.svg#compare"></use></svg> Remove`;
            e.target.dataset.compareAdded = 'true';
            alertify.confirm('Van Comparison')
                .setting({
                  'title': 'Van Comparison',
                  'message': `
                  <span class="semi-bold">${e.target.dataset.name}</span> added to comparison
                  ${(cookie_obj[Object.keys(cookie_obj)[0]] !== undefined) ? `
                    <br><br> <span class="semi-bold">You are comparing:</span>
                    <ul>
                      <li><span>${cookie_obj[Object.keys(cookie_obj)[0]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[0]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list_vans')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list_vans', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list_vans'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2216\\x22 height=\\x2216\\x22><use xlink:href=\\x22/themes/cbvc/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>
                      ${(cookie_obj[Object.keys(cookie_obj)[1]] !== undefined) ? `<li><span>${cookie_obj[Object.keys(cookie_obj)[1]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[1]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list_vans')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list_vans', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list_vans'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2216\\x22 height=\\x2216\\x22><use xlink:href=\\x22/themes/cbvc/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>` : ''}
                      ${(cookie_obj[Object.keys(cookie_obj)[2]] !== undefined) ? `<li><span>${cookie_obj[Object.keys(cookie_obj)[2]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[2]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list_vans')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list_vans', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list_vans'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2216\\x22 height=\\x2216\\x22><use xlink:href=\\x22/themes/cbvc/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>` : ''}
                    </ul>
                  ` : ''}
                `,
                  'labels': { ok: 'Go To Compare', cancel: 'Close' },
                  'onok': function(){ window.location.href = "/tools/van-comparison" }
                });
          } else {
            alertify.confirm('Car Comparison')
                .setting({
                  'title': 'Van Comparison',
                  'message': `
                  <span class="semi-bold">Van comparison full.</span>
                  <br><br>
                  <span>If you wish to continue remove one of the items below and add ${e.target.dataset.name} again.</span>
                  <br><br> <span class="semi-bold">You are comparing:</span>
                  <ul>
                    <li><span>${cookie_obj[Object.keys(cookie_obj)[0]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[0]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list_vans')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list_vans', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list_vans'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2216\\x22 height=\\x2216\\x22><use xlink:href=\\x22/themes/cbvc/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>
                    <li><span>${cookie_obj[Object.keys(cookie_obj)[1]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[1]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list_vans')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list_vans', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list_vans'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2216\\x22 height=\\x2216\\x22><use xlink:href=\\x22/themes/cbvc/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>
                    <li><span>${cookie_obj[Object.keys(cookie_obj)[2]]}</span><span class="reset" data-compare="${Object.keys(cookie_obj)[2]}" onclick="let cookie_obj = JSON.parse(Cookies.get('compare_list_vans')); delete cookie_obj[this.dataset.compare]; (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list_vans', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list_vans'); this.parentElement.remove(); document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').dataset.compareAdded = 'false'; document.querySelector('button[data-compare=\\x22'+this.dataset.compare+'\\x22]').innerHTML = '<svg width=\\x2216\\x22 height=\\x2216\\x22><use xlink:href=\\x22/themes/cbvc/img/icons/compare.svg#compare\\x22></use></svg>';"></span></li>
                  </ul>
                `,
                  'labels': { ok: 'Go To Compare', cancel: 'Close' },
                  'onok': function(){ window.location.href = "/tools/van-comparison" }
                });
          }
        } else {
          delete cookie_obj[e.target.dataset.compare];
          (Object.keys(cookie_obj).length !== 0) ? Cookies.set('compare_list_vans', JSON.stringify(cookie_obj)) : Cookies.remove('compare_list_vans');
          e.target.innerHTML = `<svg width="16" height="16"><use xlink:href="/themes/cbvc/img/icons/compare.svg#compare"></use></svg> Compare`;
          e.target.dataset.compareAdded = 'false';
          alertify.confirm('Van Comparison')
              .setting({
                'title': 'Van Comparison',
                'message': `<span class="semi-bold">${e.target.dataset.name}</span> removed from comparison`,
                'labels': { ok: 'Go To Compare', cancel: 'Close' },
                'onok': function(){ window.location.href = "/tools/van-comparison" }
              });
        }
      } else {
        let cookie_obj = JSON.parse(`{"${e.target.dataset.compare}":"${e.target.dataset.name}"}`);
        let cookie_string = JSON.stringify(cookie_obj)
        Cookies.set('compare_list_vans', cookie_string)
        e.target.innerHTML = `<svg width="16" height="16"><use xlink:href="/themes/cbvc/img/icons/compare-remove.svg#compare"></use></svg> Remove`;
        e.target.dataset.compareAdded = 'true';

        alertify.confirm('Van Comparison')
            .setting({
              'title': 'Van Comparison',
              'message': `<span class="semi-bold">${e.target.dataset.name}</span> added to comparison`,
              'labels': { ok: 'Go To Compare', cancel: 'Close' },
              'onok': function(){ window.location.href = "/tools/van-comparison" }
            });
      }
    })
  })

  // Share Button
  document.querySelectorAll('button.share-button').forEach((value) => {
    value.addEventListener('click', (e) => {
      e.preventDefault();
      alertify.alert('Share')
          .setting({
            'title': `Share ${e.target.dataset.car}`,
            'message': `
                <p class="share-button">
                  <a class="share-facebook" href="https://www.facebook.com/sharer/sharer.php?u=${e.target.dataset.url}" title="Share by Facebook" target="_blank">
                     <svg class="share-icon" width="26" height="26">
                        <use xlink:href="/themes/cbvc/img/icons/general/share-facebook.svg#facebook"></use>
                    </svg>
                      &nbsp;Share by Facebook
                  </a>
                </p>
                <p class="share-button">
                  <a class="share-twitter" href="https://twitter.com/intent/tweet?text=${e.target.dataset.url}" title="Share by Twitter" target="_blank">
                    <svg class="share-icon" width="26" height="26">
                       <use xlink:href="/themes/cbvc/img/icons/general/share-twitter.svg#twitter"></use>
                    </svg>
                      &nbsp;Share by Twitter
                  </a>
                </p>
                <p class="share-button">
                  <a class="share-whatsapp" href="whatsapp://send?text=I'd like to share a link with you: ${e.target.dataset.url}" data-action="share/whatsapp/share" title="Share by WhatsApp" target="_blank">
                        <svg class="share-icon" width="26" height="26">
                          <use xlink:href="/themes/cbvc/img/icons/general/share-whatsapp.svg#whatsapp"></use>
                      </svg>
                      &nbsp;Share by WhatsApp
                  </a>
                </p>
                <p class="share-button">
                  <a class="share-mail" href="mailto:?subject=I'd like to share a link with you&amp;body=${e.target.dataset.url}" title="Share by Email" target="_blank">
                    <svg class="share-icon" width="26" height="26">
                        <use xlink:href="/themes/cbvc/img/icons/general/share-email.svg#email"></use>
                    </svg>
                      &nbsp;Share by Email
                  </a>
                </p>`,
            'label': 'Close'
          });
    })
  })


  // Derivative Review Show More
  let reviewMore = document.querySelector('.review-content');
  let toggleLink = document.querySelector('.review-content .show-all > a');
  if (reviewMore && toggleLink) {
    toggleLink.addEventListener('click', (e) => {
      reviewMore.classList.toggle('active');
      reviewMore.classList.contains('active') ? toggleLink.querySelector('span').innerHTML = 'Show Less' : toggleLink.querySelector('span').innerHTML = 'Read Full Review'
    })
  }

  // Check if a flag in local storage indicates that the search sidebar should be open
  const isSidebarOpen = localStorage.getItem('sidebarOpen');

  if (isSidebarOpen === 'true') {
    document.body.classList.add('sidebar-active');
    localStorage.removeItem('sidebarOpen');
  }


  // Gauges
  if (document.querySelector('#charging-speeds')) {
    const gaugeOpts = {
      angle: -0.25, lineWidth: 0.18, radiusScale: 1, strokeColor: '#F2F3F3',
      generateGradient: true, highDpiSupport: true,
      pointer: { length: 0.58, strokeWidth: 0.04, color: '#2C363A' }
    }
    const gaugeHomeOpts = { colorStart: '#EEE354', colorStop: '#EBCF00'};
    const gaugeFastOpts = { colorStart: '#32E1CF', colorStop: '#32DDE1' };
    const gaugeRapidOpts = { colorStart: '#32E1C3', colorStop: '#32E18A' };
    const gaugeUltraOpts = { colorStart: '#FC4F23', colorStop: '#FC4F23' };

    function runGauge($target, $opts, $animationSpeed, $maxValue) {
      if ($target){
        let gauge = new Gauge($target).setOptions({...gaugeOpts, ...$opts});
        gauge.maxValue = $maxValue;
        gauge.setMinValue(0);
        gauge.animationSpeed = $animationSpeed;
        gauge.set(($maxValue - $target.dataset.minutes));
      }
    }

    function scrollAnimTriggerCheck() {
      runGauge(document.getElementById('gaugeHome'), gaugeHomeOpts, 500, 1440);
      runGauge(document.getElementById('gaugeFast'), gaugeFastOpts, 400, 1440);
      runGauge(document.getElementById('gaugeRapid'), gaugeRapidOpts, 300, 1440);
      runGauge(document.getElementById('gaugeUltra'), gaugeUltraOpts, 200, 1440);
    }
    document.getElementById('charging-info-tab').addEventListener("click", scrollAnimTriggerCheck);
  }

});
